import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const ptBR = {
  translation: {
    app: {
      subtitle: "Controle de Acervo",
      systemOnline: "Sistema online",
      internalUse: "uso interno",
    },
    nav: {
      dashboard: "Dashboard",
      gerencial: "Dashboard gerencial",
      agenda: "Calendário",
      operations: "Kanban",
      projects: "Projetos",
      day: "Dia",
      artworks: "Obras",
      artworkLists: "Listas de Obras",
      artists: "Artistas",
      programs: "Eventos",
      catalogs: "Catálogos",
      catalogsPipeline: "Catálogos no pipeline",
      catalogsTracking: "Rastreamento de envios",
      mediaAssets: "Banco de Mídias",
      items: "Itens",
      categories: "Categorias",
      locations: "Localizações",
      stock: "Inventário",
      movements: "Movimentações",
      recipients: "Destinatários",
      recipient_lists: "Listas",
      conversations: "Conversas",
      pipeline: "Pipeline",
      leads: "Leads",
      pedidos: "Pedidos",
      shipments: "Envios",
      kits: "Kits",
      offlineActions: "Ações Offline",
      reports: "Relatórios",
      audit: "Auditoria",
      imports: "Importar Dados",
      users: "Usuários",
      aiAssistants: "Lemy IA",
      galleryConfig: "Configuração da Galeria",
      timeline: "Timeline",
      financeiroVisaoGeral: "Visão Geral",
      financeiroReceber: "Contas a Receber",
      financeiroPagar: "Contas a Pagar",
      financeiroRepasses: "Pagamentos a Artistas",
      financeiroConciliacao: "Conciliação Bancária",
      financeiroCadastros: "Cadastros",
      financeiroDevSistema: "Desenvolvimento do Sistema",
      comunicacaoCampanhas: "Campanhas",
      comunicacaoConteudos: "Conteúdos",
      comunicacaoAtividades: "Atividades",
      comunicacaoKanban: "Kanban",
      comunicacaoCalendario: "Calendário",
      comunicacaoCalendarioEditorial: "Calendário Editorial",
      comunicacaoDashboard: "Dashboard",
      comunicacaoAprovacoes: "Aprovações",
      comunicacaoAssets: "Banco de Assets",
      comunicacaoSimulacao: "Simulação Instagram",
      comunicacaoMetricas: "Métricas",
      comunicacaoContatosImprensa: "Contatos de Imprensa",
      comunicacaoPressReleases: "Press Releases",
      campanhasEmail: "Campanhas de Email",
      group: {
        overview: "Visão Geral",
        catalog: "Catálogo",
        stock: "Estoque",
        comercial: "Comercial",
        campaigns: "Campanhas",
        financeiro: "Financeiro",
        comunicacao: "Comunicação",
        reports: "Relatórios",
        admin: "Admin",
      },
    },
    comunicacao: {
      campanhas: "Campanhas",
      novaCampanha: "Nova campanha",
      editarCampanha: "Editar campanha",
      definirCapa: "Definir/alterar imagem principal",
      urlImagemPlaceholder: "Colar URL de uma imagem (https://...)",
      usarUrl: "Usar URL",
      novoConteudo: "Novo conteúdo",
      semCampanhas: "Nenhuma campanha cadastrada.",
      emBreve: "em breve (próxima fase)",
      conteudos: "Conteúdos",
      editarConteudo: "Editar conteúdo",
      semConteudos: "Nenhum conteúdo cadastrado.",
      semCampanha: "Sem campanha",
      registrarPublicacao: "Registrar publicação",
      checklistPublicacao: "Checklist de publicação",
      novoItemChecklist: "Adicionar item ao checklist…",
      removerItemChecklist: "Remover item",
      aprovacao: "Aprovação",
      aprovar: "Aprovar",
      reprovar: "Reprovar",
      solicitarAjuste: "Solicitar ajuste",
      comentarioAprovacao: "Comentário (obrigatório para reprovar/ajuste)",
      comentarioObrigatorio:
        "Comentário é obrigatório para reprovar ou solicitar ajuste.",
      historicoAprovacao: "Histórico de aprovação",
      comentarios: "Comentários",
      semComentarios: "Nenhum comentário ainda.",
      escreverComentario: "Escrever um comentário...",
      comentar: "Comentar",
      detalhes: "Detalhes",
      assetsVinculados: "Assets vinculados",
      atividadesGeradas: "Atividades geradas",
      metricasRegistradas: "Métricas registradas",
      campoConteudo: {
        titulo: "Título interno",
        campanha: "Campanha",
        canal: "Canal",
        formato: "Formato",
        pilar: "Pilar de conteúdo",
        dataPrevista: "Data prevista",
        publicadoEm: "Publicado em",
        status: "Status",
        legenda: "Legenda",
        altText: "Texto alternativo",
        hashtags: "Hashtags",
        link: "Link de destino",
      },
      contentStatus: {
        ideia: "Ideia",
        pendente: "Pendente",
        em_producao: "Em produção",
        aguardando_material: "Aguardando material",
        texto_em_revisao: "Texto em revisão",
        design_em_revisao: "Design em revisão",
        aguardando_aprovacao: "Aguardando aprovação",
        ajustes_solicitados: "Ajustes solicitados",
        aprovado: "Aprovado",
        agendado: "Agendado",
        publicado: "Publicado",
        metricas_pendentes: "Métricas pendentes",
        concluido: "Concluído",
        cancelado: "Cancelado",
        gaveta: "Gaveta",
      },
      atividades: "Atividades",
      novaAtividade: "Nova atividade",
      editarAtividade: "Editar atividade",
      semAtividades: "Nenhuma atividade cadastrada.",
      semItensCalendario: "Nada no período com esses filtros.",
      concluir: "Concluir",
      checklist: "Checklist",
      semChecklist: "Nenhum item de checklist.",
      adicionarItem: "Adicionar item...",
      adicionar: "Adicionar",
      anexos: "Anexos",
      apenasAtrasadas: "Só atrasadas",
      apenasAprovacoesPendentes: "Só aprovações pendentes",
      apenasMinhas: "Só minhas",
      kanban: "Kanban de Produção",
      kanbanDica: "Arraste os cards entre colunas para mudar o status",
      kanbanMode: { content: "Conteúdos", activity: "Atividades" },
      calendario: "Calendário de Atividades",
      hoje: "Hoje",
      canais: {
        cores: "Cores dos canais",
        coresDica: "A cor e o nome escolhidos aqui aparecem nas etiquetas de canal dos calendários, para toda a equipe.",
        rotulo: "Nome do canal",
        cor: "Cor",
        todos: "Todos os canais",
      },
      view: {
        mes: "Mês",
        semana: "Semana",
        lista: "Lista",
        porCanal: "Por Canal",
      },
      editorial: {
        titulo: "Calendário Editorial",
        subtitulo: "A agenda de publicações da galeria, organizada por canal.",
        stats: "{{count}} publicações agendadas · {{canais}} canais",
        filtroCanais: "Todos os canais",
        filtroCampanhas: "Todas as campanhas",
        filtroArtistas: "Todos os artistas / exposições",
        filtroStatus: "Todos os status",
        previaPorCanal: "Prévia — Por Canal",
        vistaCompleta: 'vista completa em "Por Canal"',
        legenda: "Legenda",
        canaisLabel: "Canais",
        statusLabel: "Status",
        semPublicacoes: "Nenhuma publicação no período com esses filtros.",
        bucketProducao: "Em produção",
        bucketAgendado: "Agendado",
        bucketPublicado: "Publicado",
        semCanal: "Sem publicações neste canal",
      },
      dashboard: "Dashboard",
      aprovacoes: "Aprovações",
      pendentes: "pendentes",
      semAprovacoesPendentes: "Nenhuma aprovação pendente.",
      somenteAprovadorAge: "Somente aprovadores podem agir aqui.",
      naFilaDias: "na fila há {{count}}d",
      naFilaHoras: "na fila há {{count}}h",
      naFilaAgora: "na fila há pouco",
      semResultadosFiltro: "Nenhum item com esses filtros.",
      aprovFiltro: {
        all: "Todos",
        content: "Conteúdos",
        activity: "Atividades",
        campanhaTodas: "Campanha: todas",
        canalTodos: "Canal: todos",
        prioridadeTodas: "Prioridade: todas",
      },
      aprovSort: {
        queue_old: "Mais antigo na fila",
        queue_new: "Mais recente na fila",
        planned: "Por data prevista",
        priority: "Por prioridade",
      },
      entidade: {
        content: "Conteúdo",
        activity: "Atividade",
      },
      kpi: {
        campanhasAtivas: "Campanhas ativas",
        conteudosProducao: "Conteúdos em produção",
        atividadesAbertas: "Atividades abertas",
        atrasadas: "Atrasadas",
        aguardandoAprovacao: "Aguardando aprovação",
        aprovados: "Aprovados",
        agendados: "Agendados",
        publicadosMes: "Publicados no mês",
        metricasPendentes: "Métricas pendentes",
        assetsPendentes: "Assets pendentes",
      },
      grafico: {
        conteudosPorStatus: "Conteúdos por status",
        atividadesPorStatus: "Atividades por status",
        publicacoesPorCanal: "Publicações por canal",
      },
      instagram: {
        titulo: "Instagram",
        atualizado: "atualizado em",
        seguidores: "Seguidores",
        em30dias: "nos últimos 30 dias",
        alcance30d: "Alcance (30d)",
        interacoes30d: "Interações (30d)",
        visitasPerfil30d: "Visitas ao perfil (30d)",
        cliquesSite30d: "Cliques no site (30d)",
        alcanceDiario: "Alcance diário",
      },
      instagramPost: {
        titulo: "Métricas do Instagram",
        vincular: "Vincular",
        revincular: "Revincular",
        vinculado: "Post vinculado ao Instagram.",
        puxar: "Puxar métricas do Instagram",
        coletado: "Métricas coletadas do Instagram.",
        ajuda: "Cole o link do post publicado para puxar as métricas automaticamente.",
      },
      contentStories: {
        titulo: "Stories do Instagram",
        selecionar: "Selecionar stories",
        alterar: "Alterar seleção",
        ajudaSelecao:
          "Marque as stories que pertencem a este conteúdo. Um conteúdo pode ter várias.",
        ajudaVazio:
          "Story não tem link de post: selecione na lista as stories já coletadas para ver as métricas somadas aqui.",
        semColetadas: "Nenhuma story coletada ainda. A coleta roda de hora em hora.",
        jaEmOutro: "Já vinculada a outro conteúdo",
        selecionadas: "{{count}} selecionada(s)",
        views: "views",
        alcance: "alcance",
        interacoes: "interações",
        respostas: "respostas",
        notaSoma:
          "Somatório das stories selecionadas. A coleta atualiza de hora em hora enquanto a story está no ar.",
        erroSalvar: "Erro ao salvar as stories.",
        erroCarregar: "Não foi possível carregar as stories.",
      },
      bancoAssets: "Banco de Assets",
      novoAsset: "Novo asset",
      editarAsset: "Editar asset",
      semAssets: "Nenhum asset cadastrado.",
      selecionarArquivo: "Selecionar arquivo",
      selecionarArquivos: "Selecionar arquivos",
      uploadOuUrl: "Envie um arquivo ou informe uma URL externa abaixo",
      uploadArquivo: "Selecione um ou mais arquivos para enviar",
      uploadArquivosInvalidos: "Há arquivos inválidos na lista. Remova-os ou troque o tipo antes de enviar.",
      uploadFalhasParciais: "{{count}} arquivo(s) falharam no envio e continuam na lista. Tente novamente.",
      nomeLoteHint: "Com vários arquivos, cada asset recebe o nome do próprio arquivo.",
      assetSource: { file: "Arquivo", url: "URL externa", list: "Lista de Obras" },
      vincularLista: "Vincular Lista de Obras",
      selecioneLista: "Selecione uma lista…",
      verLista: "Ver lista",
      enviando: "Enviando...",
      enviandoPct: "Enviando… {{pct}}%",
      enviandoLote: "Enviando arquivo {{atual}} de {{total}}… {{pct}}%",
      baixarAsset: "Baixar arquivo original",
      expandirMidia: "Ampliar mídia",
      igSpecsHint: "Specs do Instagram: foto até 30 MB (JPEG/PNG); vídeo MP4/MOV — Story até 60s, Feed até 60 min.",
      igValidation: {
        imageFormat: "Formato de imagem não aceito pelo Instagram (use JPEG, PNG ou WEBP).",
        imageSize: "Imagem excede o limite do Instagram ({{max}} MB).",
        videoFormat: "Formato de vídeo não aceito pelo Instagram (use MP4 ou MOV).",
        videoSize: "Vídeo excede o limite do Instagram ({{max}} GB).",
        storyDuration: "Vídeo de Story não pode passar de 60s (o seu tem {{actual}}).",
        feedDuration: "Vídeo não pode passar de 60 min (o seu tem {{actual}}).",
        docSize: "Arquivo excede o limite ({{max}} MB).",
      },
      confirmarExcluirAsset: "Excluir este asset?",
      campoAsset: {
        nome: "Nome do asset",
        tipo: "Tipo",
        direitoUso: "Direito de uso",
        status: "Status",
        credito: "Crédito da imagem",
        urlExterna: "URL externa",
        caminhoStorage: "Caminho no storage",
        urlPublica: "URL pública",
        campanha: "Campanha",
      },
      assetType: {
        imagem_original: "Imagem original",
        imagem_tratada: "Imagem tratada",
        video: "Vídeo",
        arte_final: "Arte final",
        story: "Story",
        carrossel: "Carrossel",
        texto: "Texto",
        release: "Release",
        press_kit: "Press kit",
        catalogo: "Catálogo",
        pdf: "PDF",
        logo: "Logo",
        convite: "Convite",
        foto_exposicao: "Foto de exposição",
        foto_obra: "Foto de obra",
        foto_artista: "Foto de artista",
        foto_bastidor: "Foto de bastidor",
      },
      assetStatus: {
        recebido: "Recebido",
        em_tratamento: "Em tratamento",
        em_revisao: "Em revisão",
        aprovado_para_uso: "Aprovado para uso",
        uso_restrito: "Uso restrito",
        publicado: "Publicado",
        arquivado: "Arquivado",
        nao_usar: "Não usar",
      },
      usageRights: {
        autorizado: "Autorizado",
        pendente: "Pendente",
        restrito: "Restrito",
        uso_interno: "Uso interno",
        imprensa: "Imprensa",
        redes_sociais: "Redes sociais",
        nao_usar: "Não usar",
      },
      excluir: "Excluir",
      confirmarExclusao: "Tem certeza que deseja excluir? Esta ação não pode ser desfeita.",
      recados: "Recados / Post-its",
      semRecados: "Nenhum recado ainda.",
      novoRecado: "Escrever um recado...",
      adicionarRecado: "Adicionar recado",
      flutuar: "Flutuar",
      compartilhar: "Compartilhar",
      privado: "Privado",
      vincular: "Vincular",
      vincularAsset: "Vincular asset",
      desvincular: "Desvincular",
      semAssetsVinculados: "Nenhum asset vinculado.",
      semAnexos: "Nenhum anexo.",
      registrarMetrica: "Registrar métrica",
      metricaSoPublicado: "Métricas ficam disponíveis após publicar o conteúdo.",
      semMetricas: "Nenhuma métrica registrada ainda.",
      metricaAtual: "atual",
      dataColeta: "Data da coleta",
      metricasConsolidadasNota:
        "Consolidado das coletas mais recentes de cada conteúdo publicado da campanha.",
      simulacaoInstagram: "Simulação Instagram",
      previewNaoPublica: "Pré-visualização — não publica no Instagram",
      telaCheia: "Tela cheia",
      conteudoSimulado: "Conteúdo em simulação",
      temaEscuro: "Tema escuro",
      abrirDetalheConteudo: "Abrir detalhe do conteúdo",
      simSemImagem: "Este conteúdo ainda não tem mídia (imagem ou vídeo).",
      simAdicionarImagem: "Adicionar asset",
      simMode: {
        post: "Post",
        grade: "Grade do perfil",
      },
      sim: {
        subtitulo: "Veja a peça como ela vai aparecer no Instagram — para revisão e aprovação, antes da postagem.",
        visualizacao: "Visualização",
        gradeExplica: "A grade insere o post novo na 1ª posição do perfil real @galerialeme (contorno amarelo) — para avaliar a harmonia visual do feed antes de aprovar.",
        tema: "Tema do preview",
        tema_claro: "Claro",
        tema_escuro: "Escuro",
        metadados: "Metadados",
        publicacaoPrevista: "Publicação prevista",
        responsavelTexto: "Responsável (texto)",
        design: "Design",
        aprovadora: "Aprovadora",
        legenda: "Legenda",
        caracteres: "caracteres",
        verChecklistCompleta: "Ver checklist completa ({{count}} itens)",
        aprovacaoTitulo: "Aprovação",
        aguardandoAprovacao: "Aguardando aprovação de {{name}}.",
        semAprovacaoPendente: "Sem aprovação pendente para este conteúdo.",
        verNaFila: "Ver na fila de Aprovações",
        outrosFormatos: "Outros formatos (representação estática — Feed é o completo)",
        rodape: "Simulação local, apenas para conferência visual e aprovação. Nenhum dado é enviado ao Instagram — a publicação continua sendo agendada na ferramenta externa (checklist do conteúdo).",
      },
      campoAtividade: {
        titulo: "Título",
        tipo: "Tipo",
        status: "Status",
        prioridade: "Prioridade",
        inicio: "Início",
        prazo: "Prazo",
        campanha: "Campanha",
        conteudo: "Conteúdo",
        responsavel: "Responsável",
        descricao: "Descrição",
      },
      activityStatus: {
        pendente: "Pendente",
        em_producao: "Em produção",
        aguardando_material: "Aguardando material",
        em_revisao: "Em revisão",
        aguardando_aprovacao: "Aguardando aprovação",
        ajustes_solicitados: "Ajustes solicitados",
        aprovado: "Aprovado",
        agendado: "Agendado",
        publicado: "Publicado",
        metricas_pendentes: "Métricas pendentes",
        concluido: "Concluído",
        cancelado: "Cancelado",
        gaveta: "Gaveta",
      },
      activityType: {
        producao_texto: "Produção de texto",
        producao_design: "Produção de design",
        revisao: "Revisão",
        aprovacao: "Aprovação",
        publicacao: "Publicação",
        agendamento: "Agendamento",
        envio_newsletter: "Envio de newsletter",
        release_imprensa: "Release para imprensa",
        cobertura_evento: "Cobertura de evento",
        captacao_imagem: "Captação de imagem",
        edicao_video: "Edição de vídeo",
        coleta_metricas: "Coleta de métricas",
        reuniao_pauta: "Reunião de pauta",
        follow_up: "Follow-up",
        administrativa: "Administrativa",
        outra: "Outra",
      },
      priority: {
        baixa: "Baixa",
        media: "Média",
        alta: "Alta",
        urgente: "Urgente",
      },
      equipeDetalhes: "Equipe e detalhes",
      campo: {
        nome: "Nome da campanha",
        tipo: "Tipo",
        objetivo: "Objetivo",
        publicoAlvo: "Público-alvo",
        mensagemPrincipal: "Mensagem principal",
        status: "Status",
        dataInicio: "Data inicial",
        dataFim: "Data final",
        evento: "Evento",
        responsavel: "Responsável",
        canais: "Canais",
        linkPrincipal: "Link principal",
        descricao: "Descrição",
        observacoes: "Observações",
      },
      status: {
        planejamento: "Planejamento",
        em_producao: "Em produção",
        em_aprovacao: "Em aprovação",
        ativa: "Ativa",
        encerrada: "Encerrada",
        arquivada: "Arquivada",
        cancelada: "Cancelada",
      },
      aba: {
        visaoGeral: "Visão Geral",
        conteudos: "Conteúdos",
        atividades: "Atividades",
        assets: "Assets",
        metricas: "Métricas",
      },
      contadores: {
        conteudos: "Conteúdos",
        atividades: "Atividades",
        atividadesAbertas: "Atividades abertas",
        atrasadas: "Atrasadas",
        aguardandoAprovacao: "Aguard. aprovação",
        diasAteAbertura: "Dias até a abertura",
      },
      metricas: {
        titulo: "Métricas",
        subtitulo: "Painel de desempenho dos canais de comunicação",
        canalInstagram: "Instagram",
        canalSite: "Site · GA4",
        canalNewsletter: "Newsletter · Mailchimp",
        emBreve: "Fase 2",
        abaConta: "Conta & Audiência",
        abaPosts: "Posts",
        abaStories: "Stories",
        postsEmBreve: "Métricas por post chegam na próxima fase.",
        erroCarregarTitulo: "Não foi possível carregar as métricas",
        erroCarregar: "Não foi possível carregar as métricas. Tente novamente.",
        noPeriodo: "no período",
        semSerie: "Sem série no período.",
        canalAriaLabel: "Canal",
        fonte: {
          conta: "Fonte: BigQuery · atualizado diariamente",
          posts: "Fonte: Instagram Graph API · dados ao vivo",
          stories: "Fonte: Instagram Graph API · coleta a cada hora · sem histórico anterior",
          newsletter: "Fonte: Mailchimp · dados sincronizados manualmente",
        },
        site: {
          fonte: "Fonte: GA4 do galerialeme.com · exportação diária para o BigQuery · dados até {{fim}}",
          abaVisaoGeral: "Visão geral",
          abaPaginas: "Páginas",
          periodo7: "7 dias",
          periodo30: "30 dias",
          periodo90: "90 dias",
          periodoAria: "Período",
          avisoTitulo: "Só visitas reais.",
          aviso: "No período o GA4 registrou {{registradas}} visitas. {{robos}} eram robôs, {{semLeitura}} saíram em menos de 2 segundos e {{equipe}} eram da própria equipe. O painel conta as {{reais}} visitas em que alguém leu a página.",
          kpiReais: "Visitas reais",
          kpiBrasil: "Do Brasil",
          kpiPaginas: "Páginas lidas",
          kpiTempo: "Tempo de leitura",
          kpiPedidos: "Pedidos de informação",
          kpiBrasilHint: "{{pct}}% das visitas reais",
          kpiPaginasHint: "{{n}} por visita",
          kpiTempoHint: "média por visita real",
          kpiPedidosHint: "formulários abertos, sem contar a busca",
          vsAnterior: "{{sinal}}{{pct}}% vs período anterior ({{valor}})",
          mesesTitulo: "Visitas por mês · reais × registradas",
          legReais: "reais",
          legOutras: "robôs e saídas sem leitura",
          origensTitulo: "De onde vêm as visitas",
          colOrigem: "Origem",
          colChegaram: "Chegaram",
          colLeram: "Leram",
          colPct: "% que leu",
          origem: {
            busca: "Busca (Google e outros)",
            direto: "Direto ou link salvo",
            redes: "Instagram e Facebook orgânico",
            email: "E-mail",
            anuncios: "Anúncios",
            ia: "Assistentes de IA (ChatGPT e outros)",
            outros_sites: "Outros sites",
            outros: "Sem origem identificada",
          },
          tipos: {
            artista: "Artistas",
            exposicao: "Exposições",
            viewing_room: "Viewing Room",
            obra: "Obras",
            todas: "Todas as páginas",
          },
          buscaPlaceholder: "Buscar página ou título",
          soSemVinculo: "só sem vínculo no Acervo",
          colPagina: "Página",
          colLeituras: "Leituras",
          colSemLeitura: "Sem leitura",
          colTempo: "Tempo por leitura",
          colAcervo: "No Acervo",
          abrirAcervo: "abrir no Acervo",
          semCadastro: "sem cadastro",
          duplicada: "página duplicada no site",
          vinculoProximaFase: "vínculo na próxima fase",
          notaPaginas: "Leitura = página vista numa visita real. Sem leitura = página aberta por quem saiu em menos de 2 segundos. Robôs e equipe ficam fora. Português e inglês somados.",
          nenhumaPagina: "Nenhuma página encontrada.",
          qtdPaginas: "{{n}} páginas",
          semDados: "Sem dados do site no período.",
          naoConfigurado: "O BigQuery não está configurado no servidor.",
          comoContamos: "Como contamos: uma visita é real quando a pessoa fica pelo menos 2 segundos com a página aberta e vê ao menos uma página. Robôs (navegador com assinatura conhecida) e a equipe da galeria (site de teste, gerenciador do Meta, Mailchimp) ficam fora.",
          carregando: "Lendo os dados do site… a primeira consulta do dia leva alguns segundos.",
          card: {
            titulo: "No site · últimos 30 dias",
            leituras: "leituras da página do artista",
            posicao: "{{pos}}º entre {{total}} artistas",
            vs: "{{sinal}}{{pct}}% vs 30 dias anteriores ({{valor}})",
            origens: "Origem das leituras",
            semDados: "Nenhuma leitura da página do artista no período.",
            verRelatorio: "ver relatório do site",
          },
        },
        newsletter: {
          tituloSecao: "Newsletter",
          subtitulo: "{{count}} campanhas nos últimos 12 meses",
          kpis: {
            campanhas12m: "Campanhas (12m)",
            taxaAberturaMedia: "Taxa de Abertura Média (12m)",
            referenciaConta: "referência da conta: {{pct}}",
            cliquesHumanos: "Cliques Humanos",
            cliquesHumanosHint: "{{human}} humanos · {{bot}} bot",
            cliquesHumanosComparativo: "histórico completo: {{pct}} humano",
            cliquesHumanosExplicacao:
              "Um clique é marcado como provável bot quando acontece antes da abertura do e-mail, ou em grupo (3 ou mais no mesmo segundo) — assinatura típica de scanner corporativo (Safe Links, Proofpoint). É uma estimativa, não uma certeza absoluta.",
            ultimaSincronizacao: "Última Sincronização",
            nuncaSincronizado: "nunca sincronizado",
          },
          evolucao: {
            titulo: "Evolução das Campanhas",
            ariaLabel: "Gráfico de evolução da taxa de abertura e taxa de clique por campanha",
            legendaAbertura: "Taxa de abertura",
            legendaClique: "Taxa de clique",
          },
          melhorEnvio: {
            tituloSecao: "Melhor Dia / Melhor Horário para Enviar",
            melhorDia: "Melhor Dia",
            melhorHorario: "Melhor Horário",
            amostraInsuficiente: "Amostra insuficiente para recomendar.",
            campanhasAnalisadas: "com base em {{count}} campanhas",
          },
          lista: {
            titulo: "Últimas Campanhas",
            verTodas: "Ver todas as campanhas",
            colCampanha: "Campanha",
            colData: "Data",
            colAbertura: "Tx. abertura",
            colClique: "Tx. clique",
          },
          vazio: {
            titulo: "Nenhuma campanha sincronizada ainda",
            descricao:
              "Sincronize os relatórios de campanhas do Mailchimp para ver as métricas de newsletter aqui.",
            cta: "Ir para Campanhas de Email",
          },
        },
        conta: {
          tituloSecao: "Desempenho do Perfil",
          ultimosDias: "últimos {{dias}} dias",
          seguidores: "Seguidores",
          alcance: "Alcance",
          alcanceHint: "contas únicas alcançadas",
          visualizacoes: "Visualizações",
          visualizacoesHint: "views de conteúdo",
          interacoes: "Interações",
          interacoesHint: "curtidas · coment. · salvos",
          contasEngajadas: "Contas Engajadas",
          contasEngajadasHint: "interagiram no período",
          visitasPerfil: "Visitas ao Perfil",
          visitasPerfilHint: "aberturas do perfil",
        },
        naoConfigurado: {
          titulo: "Integração BigQuery não configurada",
          descricaoPre:
            "As métricas do Instagram são lidas ao vivo do BigQuery. Para exibi-las aqui, conceda à service account",
          descricaoMeio: "os papéis",
          e: "e",
          descricaoProjeto: "no projeto",
        },
        semDados: {
          titulo: "Sem dados no período",
          descricao:
            "A integração está configurada, mas ainda não há dados carregados para este período no BigQuery.",
        },
        evolucao: {
          titulo: "Evolução no Período",
          ariaLabel: "Gráfico de evolução de seguidores, interações e alcance diário",
          legendaAlcanceDiario: "Alcance diário",
        },
        engajamento: {
          titulo: "Taxa de Engajamento",
          subtitulo: "interações ÷ alcance, por semana",
          legendaBarra: "Barra amarela = melhor semana",
        },
        acoesPerfil: {
          titulo: "Ações no Perfil",
          cliquesSite: "Cliques no Site",
          cliquesSiteHint: "link da bio → galerialeme.com",
          tapsLinks: "Taps em Links do Perfil",
          tapsLinksHint: "total de toques em links",
          telefoneEmailRota: "Telefone · E-mail · Rota",
          descontinuados: "Descontinuados pela Meta em 2024.",
          descontinuadosDetalhe:
            "Não há como coletar esses toques individualmente — o Instagram deixou de expô-los na API.",
        },
        audiencia: {
          titulo: "Audiência",
          subtitulo: "foto atual dos seguidores",
          genero: {
            titulo: "Gênero",
            feminino: "Feminino",
            masculino: "Masculino",
            naoInformado: "Não informado",
          },
          faixaEtaria: {
            titulo: "Faixa Etária",
            legendaBarra: "Barra amarela = faixa dominante",
          },
          paises: {
            titulo: "Países",
          },
          cidades: {
            titulo: "Cidades",
          },
        },
        rodape: {
          nota: "Demográficos refletem sempre a foto atual da audiência — a Meta não fornece série histórica desses dados. Métricas de conta cobrem até 90 dias (limite da API); o histórico completo fica preservado no BigQuery a partir de dez/2025.",
        },
        posts: {
          tituloSecao: "Posts Recentes",
          ultimosPosts: "últimos {{count}} posts",
          periodo: {
            dias30: "Últimos 30 dias",
            dias90: "Últimos 90 dias",
            todos: "Todos",
            verAoVivo: "Ver ao vivo agora",
            contagemComData:
              "{{count}} posts no período · dados até {{date}} · atualizado 1x/dia",
          },
          naoConfiguradoTitulo: "Integração do Instagram não configurada",
          naoConfiguradoDesc:
            "As métricas por post são lidas ao vivo da Graph API do Instagram. A integração ainda não tem um token de acesso configurado para esta conta.",
          kpis: {
            alcanceMedio: "Alcance Médio",
            interacoesMedias: "Interações Médias",
            taxaEngajamento: "Taxa de Engajamento",
            taxaEngajamentoHint: "média · sobre alcance",
            salvos: "Salvos",
            views: "Views",
            porPost: "por post",
            somaPeriodo: "soma no período",
          },
          scatter: {
            titulo: "Alcance × Engajamento",
            eixoX: "taxa de engajamento →",
            eixoY: "alcance →",
            legendaMelhor: "Melhor post",
          },
          melhorPost: {
            titulo: "Melhor post",
            metricas: "Alcance {{alcance}} · Engaj. {{engaj}}",
          },
          mediaType: {
            imagem: "Imagem",
            carrossel: "Carrossel",
            reels: "Reels",
            outro: "Outro",
          },
          horario: {
            titulo: "Melhor Horário para Publicar",
            subtitulo: "alcance médio por dia",
            legenda: "concentra o maior alcance médio.",
            amostraPequena:
              "Baseado nos últimos {{count}} posts — amostra pequena, tendência indicativa.",
            dias: {
              dom: "Dom",
              seg: "Seg",
              ter: "Ter",
              qua: "Qua",
              qui: "Qui",
              sex: "Sex",
              sab: "Sáb",
            },
          },
          melhorHorario: {
            melhorDia: "Melhor dia: {{dia}} · {{alcance}} alcance médio",
            tituloFaixa: "Melhor Faixa de Horário",
            melhorFaixa: "Melhor faixa: {{faixa}} · {{alcance}} alcance médio",
            faixa: {
              manha: "Manhã",
              tarde: "Tarde",
              noite: "Noite",
            },
          },
          lista: {
            titulo: "Posts do Período",
            ordenarPor: "Ordenar por",
            alcance: "Alcance",
            salvos: "Salvos",
            views: "Views",
            interacoes: "Interações",
            engajamento: "Engaj.",
            data: "Data",
            semLegenda: "Sem legenda",
          },
          ordenar: {
            alcance: "Alcance",
            salvos: "Salvos",
            views: "Views",
            interacoes: "Interações",
            engajamento: "Engajamento",
            recente: "Mais recente",
          },
          filtro: {
            label: "Tipo",
            todos: "Todos",
            reels: "Reels",
            carrossel: "Carrossel",
            imagem: "Imagem",
          },
          nenhumDoTipo: "Nenhum post deste tipo.",
        },
        stories: {
          tituloSecao: "Stories",
          subtitulo: "{{active}} ativas de {{total}} coletadas",
          naoConfiguradoTitulo: "Integração do Instagram não configurada",
          naoConfiguradoDesc:
            "As stories são coletadas periodicamente via Graph API do Instagram. A integração ainda não tem um token de acesso configurado para esta conta.",
          semDados: {
            titulo: "A coleta ainda não rodou nenhuma vez",
            descricao:
              "Stories aparecem aqui a partir da próxima coleta (roda a cada hora). Como o Instagram não guarda histórico de stories, só é possível ver o que for coletado a partir de agora — stories publicadas antes deste recurso existir não podem ser recuperadas.",
          },
          kpis: {
            storiesAtivas: "Stories Ativas",
            alcanceMedio: "Alcance Médio",
            porStory: "por story",
            visualizacoesMedias: "Visualizações Médias",
            interacoesTotais: "Interações Totais",
            respostasTotais: "Respostas Totais",
            somaPeriodo: "soma no período",
          },
          status: {
            ativa: "Ativa",
            expirada: "Expirada",
          },
          tempo: {
            agora: "agora",
            minutos: "há {{count}}m",
            horas: "há {{count}}h",
            dias: "há {{count}}d",
            mes: "em {{monthYear}}",
          },
          mediaType: {
            imagem: "Foto",
            video: "Vídeo",
            outro: "Outro",
          },
          lista: {
            titulo: "Stories Coletadas",
            visualizacoes: "Visualizações",
            alcance: "Alcance",
            respostas: "Respostas",
            interacoes: "Interações",
            publicadaEm: "Publicada",
            dadosAte: "dados até {{time}}",
          },
        },
      },
      imprensa: {
        titulo: "Contatos de Imprensa",
        totalContatos_one: "{{countFormatted}} contato cadastrado",
        totalContatos_other: "{{countFormatted}} contatos cadastrados",
        filtrosAriaLabel: "Filtros de contatos de imprensa",
        limparBuscaAriaLabel: "Limpar busca",
        limpar: "Limpar",
        topInteresse: "Top interesse",
        contatoSelecionado: "Contato selecionado",
        busca: "Buscar jornalista, veículo...",
        filtroVeiculo: "Tipo de veículo",
        todosVeiculos: "Todos os tipos de veículo",
        colJornalista: "Jornalista",
        colVeiculo: "Veículo",
        colBeat: "Beat / Editoria",
        colCanais: "Canais",
        colScore: "Score de interesse",
        colUltimoContato: "Último contato",
        semContatos: "Nenhum contato de imprensa encontrado.",
        selecionePrompt: "Selecione um contato",
        selecionePromptSub: "Clique em uma linha da tabela para abrir o perfil completo.",
        semAtividade: "Sem interação registrada",
        optInConfirmado: "Confirmado",
        optInNaoConfirmado: "Não confirmado",
        consentimentoLgpd: "Consentimento LGPD",
        temasInteresse: "Temas de interesse",
        semTemas: "Nenhum tema registrado.",
        scoreInteresse: "Score de interesse",
        scoreNota: "Score v1 por recência das interações; enriquece com aberturas/cliques/downloads na Fase 2.",
        timelineAtividade: "Timeline de Atividade",
        semTimeline: "Nenhuma atividade registrada.",
        interacao: {
          visit: "visita",
          email: "e-mail enviado",
          whatsapp: "WhatsApp",
          phone: "ligação",
          meeting: "reunião",
          catalog_sent: "catálogo enviado",
          gift_sent: "brinde enviado",
          viewing_room_access: "acessou viewing room",
          event_attended: "compareceu a evento",
          other: "interação",
        },
        tempo: {
          agora: "agora",
          minutos: "há {{count}}m",
          horas: "há {{count}}h",
          dias: "há {{count}}d",
          mes: "em {{monthYear}}",
        },
        scoreTier: {
          alto: "Alto",
          medio: "Médio",
          baixo: "Baixo",
        },
        canalEmailCadastrado: "Email: {{email}}",
        canalSemEmail: "Sem e-mail cadastrado",
        canalWhatsappSemCanal: "WhatsApp — sem canal cadastrado",
        canalWhatsappOptInConfirmado: "WhatsApp — opt-in confirmado",
        canalWhatsappSemOptIn: "WhatsApp — sem opt-in",
        mediaOutletType: {
          revista: "Revista",
          jornal: "Jornal",
          portal_site: "Portal / Site",
          tv: "TV",
          radio: "Rádio",
          podcast: "Podcast",
          agencia: "Agência",
          independente: "Independente",
        },
      },
      pressReleases: {
        titulo: "Press Releases",
        totalReleases_one: "{{count}} release",
        totalReleases_other: "{{count}} releases",
        novoRelease: "Novo Release",
        filtrosAriaLabel: "Filtros de press releases",
        filtroStatus: "Status",
        todosStatus: "Todos os status",
        filtroExposicao: "Exposição",
        todasExposicoes: "Todas as exposições",
        filtroIdioma: "Idioma",
        todosIdiomas: "Todos os idiomas",
        idiomaPt: "Português",
        idiomaEn: "Inglês",
        colReleases: "Releases",
        noTotal_one: "{{count}} no total",
        noTotal_other: "{{count}} no total",
        semReleases: "Nenhum press release cadastrado.",
        selecionePrompt: "Selecione um release",
        selecionePromptSub: "Clique em um release na lista ou crie um novo.",
        embargoLabel: "Embargo",
        enviadoLabel: "Enviado",
        semDataDefinida: "sem data definida",
        atualizadoEm: "última edição em {{date}}",
        status: {
          rascunho: "Rascunho",
          revisao: "Revisão",
          aprovado: "Aprovado",
          embargo: "Embargo",
          enviado: "Enviado",
        },
        editor: {
          titulo: "Editor bilíngue",
          colPt: {
            header: "Português",
            titulo: "Título",
            corpo: "Corpo do texto",
          },
          colEn: {
            header: "English",
            titulo: "Title",
            corpo: "Body",
          },
          metaExposicao: "Exposição",
          metaArtista: "Artista",
          metaEmbargo: "Embargo até",
          metaStatus: "Status",
          semExposicao: "Nenhuma",
          semArtista: "Nenhum",
        },
        distribuicao: {
          titulo: "Distribuição multicanal",
          destinatarios: "Destinatários",
          destinatariosAriaLabel: "Selecionar destinatários do envio",
          destinatariosContagem: "{{selected}} de {{total}} contatos selecionados",
          semContatos: "Nenhum contato de imprensa cadastrado.",
          emailConfirmado: "E-mail confirmado",
          semEmail: "Sem e-mail cadastrado",
          whatsappOptIn: "WhatsApp com opt-in",
          whatsappSemOptIn: "Sem opt-in de WhatsApp",
          canais: "Canais de envio",
          canalEmail: "E-mail (Brevo)",
          canalEmailDesc: "Envio por e-mail com rastreio próprio de abertura e clique.",
          canalWhatsapp: "WhatsApp (template aprovado)",
          canalWhatsappDesc: "Restrito a contatos com opt-in ativo, via template categoria MARKETING pré-aprovado pela Meta. Sem opt-in ou template, o envio degrada para e-mail.",
          canalLabel: {
            email: "E-mail",
            whatsapp: "WhatsApp",
          },
          linksRastreados: "Todos os links do release são reescritos como redirecionamento rastreado — é isso que alimenta o painel de engajamento abaixo.",
          enviar: "Enviar",
          enviando: "Enviando...",
          nenhumDestinatarioErro: "Selecione ao menos um destinatário.",
          nenhumCanalErro: "Selecione ao menos um canal de envio.",
          embargoAtivo: "Este release está sob embargo até {{date}} — o envio ficará bloqueado até lá.",
          agendado: "Envio agendado — acompanhe no painel de engajamento abaixo.",
          resultado_one: "{{count}} envio agendado.",
          resultado_other: "{{count}} envios agendados.",
          puladosTitulo_one: "{{count}} destinatário pulado:",
          puladosTitulo_other: "{{count}} destinatários pulados:",
          puladoItem: "{{name}} ({{channel}}): {{reason}}",
          motivoPulado: {
            semEmail: "destinatário sem e-mail cadastrado",
            semTelefone: "destinatário sem telefone cadastrado",
            semOptInWhatsapp: "sem opt-in de WhatsApp",
            generico: "{{reason}}",
          },
        },
        engajamento: {
          titulo: "Painel de engajamento",
          semDistribuicao: "Este release ainda não foi distribuído.",
          semDistribuicaoSub: "Envie o release na seção de distribuição acima para começar a acompanhar aberturas, cliques e downloads.",
          funil: "Funil de distribuição",
          funilEnviado: "Enviado",
          funilEntregue: "Entregue",
          funilAberto: "Aberto",
          funilClicou: "Clicou",
          funilBaixou: "Baixou",
          ranking: "Quem está mais interessado",
          colJornalista: "Jornalista",
          colVeiculo: "Veículo",
          colScore: "Score",
          colUltimoEvento: "Último evento",
          semRanking: "Nenhum destinatário ainda.",
          timelineTitulo: "Linha do tempo · {{name}}",
          timelineSemEventos: "Nenhum evento registrado ainda para este destinatário.",
          selecionarParaTimeline: "Ver linha do tempo de {{name}}",
          ressalva: "Abertura de e-mail é sinal fraco (o Apple Mail Privacy Protection infla essa métrica automaticamente); clique e download são os sinais confiáveis para priorizar follow-up. \"Lido\" no WhatsApp é aproximado e depende das configurações de privacidade de cada contato.",
          eventType: {
            delivered: "Entregue",
            opened: "Aberto",
            clicked: "Clicou",
            asset_downloaded: "Baixou material",
            bounced: "Retornou (bounce)",
          },
        },
      },
    },
    recipient_lists: {
      kind: {
        static: "Estática",
        dynamic: "Dinâmica",
      },
      status: {
        active: "Ativa",
        archived: "Arquivada",
      },
      count: {
        contacts: "Contatos",
        today: "Hoje",
      },
      bulk: {
        select_lists_placeholder: "Escolha uma lista destino…",
        add_to_list: "Adicionar a uma lista",
        selected: "{{n}} selecionados",
        modal_title: "Adicionar {{n}} contatos a uma lista",
        added: "{{n}} adicionados",
        duplicates: "{{n}} já estavam na lista",
        clear: "Limpar seleção",
      },
    },
    common: {
      save: "Salvar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      create: "Criar",
      edit: "Editar",
      view: "Ver catálogo",
      delete: "Excluir",
      remove: "Remover",
      search: "Buscar",
      loading: "Carregando...",
      noResults: "Nenhum resultado encontrado.",
      required: "Campo obrigatório",
      viewAll: "Ver todos",
      all: "Todos",
      allTypes: "Todos os tipos",
      select: "Selecionar...",
      next: "Próximo",
      back: "Voltar",
      close: "Fechar",
      retry: "Tentar novamente",
      new: "Novo",
      comingSoon: "Em breve",
      notifications: "Notificações",
      userMenu: "Menu do usuário",
      errorTitle: "Erro ao carregar",
      errorMessage: "Ocorreu um erro ao carregar os dados.",
      showingOf: "Mostrando {{from}}–{{to}} de {{total}}",
      yes: "Sim",
      no: "Não",
      download: "Baixar",
    },
    dashboard: {
      title: "Visão Geral",
      updated: "Atualizado agora",
      totalItems: "Total de Itens",
      distributed: "Distribuídos / Mês",
      criticalStock: "Estoque Crítico",
      activeKits: "Kits Ativos",
      inLocations: "Em localizações",
      thisMonth: "Este mês",
      belowThreshold: "Abaixo do mínimo",
      remaining: "restantes",
      noAlerts: "Nenhum alerta de estoque.",
      recentShipments: "Envios Recentes",
    },
    artworks: {
      title: "Obras",
      registered: "obras cadastradas",
      new: "Nova Obra",
      edit: "Editar Obra",
      search: "Buscar por título, artista ou código",
      artistSearch: "Filtrar por artista",
      empty: "Nenhuma obra cadastrada",
      emptyMessage: "Cadastre a primeira obra para iniciar o domínio comercial.",
      section: {
        identification: "Identificação",
        technical: "Ficha Técnica",
        notes: "Observações",
      },
      field: {
        title: "Título",
        artist: "Artista",
        internalCode: "Código interno",
        legacyCode: "Código legado",
        year: "Ano",
        medium: "Técnica",
        support: "Suporte",
        dimensions: "Dimensões",
        edition: "Edição",
        location: "Localização",
        status: "Status",
        price: "Preço",
        currency: "Moeda",
        image: "Imagem principal",
        imageUrl: "URL da imagem",
        notes: "Observações",
      },
      media: {
        select: "Selecionar da biblioteca",
        clear: "Limpar imagem",
        noSelection: "Nenhuma mídia selecionada.",
        urlFallback: "Imagem definida por URL manual.",
        selectTitle: "Selecionar imagem da obra",
        search: "Buscar no banco de mídias",
      },
      status: {
        available: "Disponível",
        loaned: "Emprestada",
        reserved: "Reservada",
        consigned_client: "Consignada cliente",
        sold: "Vendida",
        returned_to_consignor: "Devolvida ao consignante",
        donated: "Doada",
        destroyed: "Destruída",
        undefined: "Indefinido",
        unavailable: "Indisponível",
      },
      form: {
        errorRequired: "Título e artista são obrigatórios.",
      },
      delete: {
        title: "Excluir obra",
        message: "Tem certeza que deseja excluir \"{{title}}\"? Esta ação faz soft delete do registro.",
      },
    },
    catalogs: {
      title: "Catálogos Comerciais",
      registered: "catálogos cadastrados",
      new: "Novo Catálogo",
      edit: "Editar Catálogo",
      search: "Buscar por nome ou slug",
      searchWorks: "Buscar obras por título, artista ou código",
      empty: "Nenhum catálogo cadastrado",
      emptyMessage: "Crie o primeiro catálogo comercial para montar seleções de obras.",
      selectedCount: "obras selecionadas",
      emptySelection: "Nenhuma obra selecionada ainda.",
      field: {
        name: "Nome",
        slug: "Slug",
        coverMedia: "Capa do catálogo",
        coverMediaEmpty: "Nenhuma capa selecionada ainda.",
        introText: "Texto de introdução",
        status: "Status",
        liveUpdating: "Atualização automática do conteúdo",
        notes: "Observações",
        addWorks: "Adicionar obras",
        visible: "Visível",
        sortOrder: "Ordem",
        layout: "Layout",
        primaryArtwork: "Obra principal",
        secondaryArtwork: "Obra secundária",
        viewImage: "Imagem de vista",
        coverFromLibrary: "Selecionar capa",
        clearCover: "Limpar capa",
        selectArtwork: "Selecionar obra",
        selectSecondaryArtwork: "Selecionar obra 2",
        selectViewImage: "Selecionar vista",
        clearArtwork: "Limpar obra",
        clearSecondaryArtwork: "Limpar obra 2",
        clearViewImage: "Limpar vista",
        selectArtworkHelp: "Adicione spreads e, em cada um, selecione da biblioteca a vista e as obras que entram naquela página.",
      },
      assembly: {
        title: "Montagem por spreads",
        empty: "Monte o catálogo página a página, escolhendo layout, obra principal, obra secundária e imagem de vista quando necessário.",
      },
      metrics: {
        spreads: "Spreads",
        updating: "Atualização",
        updatedAt: "Atualizado em",
      },
      preview: {
        title: "Preview Real do Catálogo",
        spreads: "spreads",
        empty: "Adicione obras e imagens de vista para visualizar o catálogo final.",
        open: "Ver preview real",
        hint: "Visualização separada da montagem, aproximando o resultado final do catálogo/PDF.",
        sectionCover: "Capa",
        sectionIntro: "Introdução",
        sectionSpread: "Spread {{number}}",
      },
      spread: {
        title: "Spreads do catálogo",
        add: "Adicionar spread",
        remove: "Remover spread",
        empty: "Nenhum spread adicionado ainda.",
      },
      picker: {
        coverTitle: "Selecionar capa da biblioteca",
        viewTitle: "Selecionar imagem de vista",
        artworkTitle: "Selecionar obra principal",
        secondaryArtworkTitle: "Selecionar obra secundária",
        empty: "Nenhum resultado encontrado.",
      },
      status: {
        draft: "Rascunho",
        active: "Ativo",
        archived: "Arquivado",
      },
      layout: {
        vista: "Vista",
        "vista-dir": "Vista à direita",
        "vista-full": "Vista em página inteira",
        full: "Obra + ficha",
        "full-dir": "Ficha + obra",
        "dupla-esq": "Dupla esquerda",
        "dupla-dir": "Dupla direita",
        "obra-texto": "Obra + texto curatorial",
        "texto-obra": "Texto curatorial + obra",
        "texto-pagina": "Página de texto",
        "capa-artista": "Capa de artista",
        ocultar: "Ocultar",
      },
      form: {
        errorRequired: "Nome e slug são obrigatórios.",
      },
      delete: {
        message: "Tem certeza que deseja excluir \"{{name}}\"? O catálogo será removido logicamente.",
      },
      delivery: {
        cta: "Gerar link",
        activeOnly: "O catálogo precisa estar ativo para gerar link público.",
        title: "Link individual do catálogo",
        searchRecipient: "Selecionar destinatário",
        searchPlaceholder: "Buscar destinatário por nome, email ou telefone",
        emptyRecipients: "Nenhum destinatário encontrado.",
        selectRecipientHint: "Selecione um destinatário para gerar o link individual.",
        generate: "Gerar link",
        generatedLink: "Link gerado",
        openPublic: "Abrir página pública",
        copyLink: "Copiar link",
        trackingTitle: "Rastreamento por destinatário",
      },
      public: {
        title: "Catálogo Público",
        opens: "Aberturas",
        clicks: "Cliques",
        favorites: "Favoritos",
        selected: "Seleções",
      },
    },
    mediaAssets: {
      title: "Banco de Mídias",
      registered: "arquivos cadastrados",
      new: "Novo Arquivo",
      add: "Adicionar arquivo",
      edit: "Editar Arquivo",
      search: "Buscar por nome, caminho ou texto alternativo",
      empty: "Nenhum arquivo cadastrado",
      emptyMessage: "Cadastre o primeiro ativo de mídia para reutilizar em obras, catálogos e conversas.",
      upload: "Upload do arquivo",
      selectFile: "Selecionar arquivo",
      changeFile: "Trocar arquivo",
      selectFiles: "Selecionar arquivos",
      changeFiles: "Trocar arquivos",
      filesSelected: "{{count}} arquivo(s) selecionado(s)",
      previewFirstOfMany: "Mostrando o preview do 1º de {{count}} arquivos selecionados.",
      previewEmpty: "Selecione um arquivo para visualizar o preview.",
      previewUnavailable: "Preview indisponível para este tipo de arquivo.",
      previewPdf: "Arquivo PDF pronto para upload.",
      field: {
        kind: "Tipo",
        originalName: "Nome original",
        fileName: "Nome do arquivo",
        mimeType: "MIME type",
        fileSize: "Tamanho do arquivo",
        storageProvider: "Storage provider",
        storagePath: "Caminho no storage",
        publicUrl: "URL pública",
        width: "Largura",
        height: "Altura",
        altText: "Texto alternativo",
        status: "Status",
        preview: "Preview",
      },
      metrics: {
        updatedAt: "Atualizado em",
        provider: "Provider",
      },
      kind: {
        artwork_image: "Imagem de obra",
        catalog_cover: "Capa de catálogo",
        catalog_view: "Imagem de vista",
        attachment: "Anexo",
        document: "Documento",
        text: "Texto",
      },
      status: {
        active: "Ativo",
        archived: "Arquivado",
      },
      form: {
        errorRequired: "Tipo, nome, arquivo, MIME, caminho e URL pública são obrigatórios.",
        errorFileRequired: "Selecione um arquivo para enviar.",
        errorFileTooLarge: "Arquivo excede o limite de {{max}}.",
        errorFileTypeNotAllowed: "Tipo de arquivo não permitido. Use JPG, PNG, WebP, GIF, MP4 ou PDF.",
        errorTooManyFiles: "Máximo de {{max}} arquivos por vez.",
        errorTotalSizeTooLarge: "Tamanho total dos arquivos excede {{max}}.",
        uploadHelp: "Envie JPG, PNG, WebP, GIF, MP4 ou PDF (máx. 50 MB cada, 500 MB total, até 20 arquivos). O caminho, a URL pública, o tipo e o tamanho serão preenchidos automaticamente após o upload. É possível selecionar vários arquivos de uma vez.",
        altTextSharedHint: "O texto alternativo será aplicado a todos os arquivos selecionados.",
        uploadingProgress: "Enviando arquivo {{done}} de {{total}}… (uploads paralelos, máx. 3 simultâneos)",
        uploadErrorsTitle: "Falha ao enviar {{count}} arquivo(s):",
      },
      delete: {
        message: "Tem certeza que deseja excluir \"{{name}}\"? O arquivo será removido logicamente.",
      },
    },
    items: {
      viewShipment: "Ver envio →",
      title: "Catálogo de Itens",
      registered: "itens cadastrados",
      new: "Novo Item",
      empty: "Nenhum item cadastrado",
      emptyMessage: "Cadastre o primeiro item do acervo.",
      tab: {
        general: "Dados Gerais",
        images: "Imagens",
        files: "Arquivos",
        stock: "Estoque",
        history: "Histórico",
      },
      section: {
        identification: "Identificação",
        acquisition: "Aquisição",
        book: "Dados do Livro",
        quick_actions: "Ações Rápidas",
        stock_summary: "Resumo de Estoque",
        locations: "Localizações",
      },
      book: {
        author: "Autor",
        isbn: "ISBN",
        publisher: "Editora",
        edition: "Edição",
        year: "Ano de Publicação",
      },
      field: {
        name: "Nome",
        code: "Código",
        category: "Categoria",
        subcategory: "Subcategoria",
        operational_type: "Tipo Operacional",
        status: "Status",
        description: "Descrição",
        origin: "Origem",
        supplier: "Fornecedor",
        acquisition_date: "Data de Aquisição",
        unit_cost: "Custo Unitário",
      },
      action: {
        entry: "Registrar Entrada",
        transfer: "Transferir",
        new_shipment: "Novo Envio",
      },
      stock: {
        total: "total em estoque",
      },
      meta: {
        created_at: "Criado em",
        updated_at: "Atualizado em",
      },
      form: {
        newTitle: "Novo item",
        editTitle: "Editar item",
        name: "Nome",
        category: "Categoria",
        subcategory: "Subcategoria",
        itemKind: "Tipo",
        status: "Status",
        productCode: "Código (SKU)",
        description: "Descrição",
        unitCost: "Custo unitário",
        origin: "Origem",
        notes: "Observações",
        coverImage: "Imagem de capa",
        coverImageHint: "Clique para selecionar uma imagem",
        coverImageReplaceHint: "Selecionar uma imagem aqui vai substituir a capa atual.",
        initialStockSection: "Estoque inicial (opcional)",
        initialQuantity: "Quantidade de entrada",
        initialLocation: "Localização inicial",
        entryDate: "Data de entrada",
        initialStockHint:
          "Preencha os três para registrar uma entrada imediata no estoque. Data aceita registros retroativos.",
        bookSection: "Informações do livro",
        bookAuthor: "Autor",
        bookIsbn: "ISBN",
        bookPublisher: "Editora",
        bookEdition: "Edição",
        bookYear: "Ano de publicação",
        errorNameRequired: "O nome é obrigatório.",
        errorQtyInvalid: "Quantidade inválida.",
        errorQtyRequired:
          "Informe a quantidade de entrada para o estoque inicial.",
        errorLocationRequired:
          "Informe a localização inicial para registrar a entrada.",
      },
      kind: {
        book: "Livro",
        catalog: "Catálogo",
        gift: "Brinde",
        bag: "Sacola",
        printed_material: "Material impresso",
        packaging: "Embalagem",
        institutional: "Item institucional",
        campaign_item: "Item de campanha",
        other: "Outros",
      },
      status: {
        active: "Ativo",
        inactive: "Inativo",
        discontinued: "Descontinuado",
      },
      origin_type: {
        purchase: "Compra",
        produced: "Produção própria",
        donated: "Doação",
        partnership: "Parceria",
        transfer_in: "Transferência externa",
      },
      delete: {
        title: "Excluir item",
        message: "Tem certeza que deseja excluir \"{{name}}\"? Esta ação marca o item como removido (soft delete).",
      },
    },
    categories: {
      title: "Categorias",
      subtitle: "Gerencie categorias e subcategorias de itens",
      panel: {
        categories: "Categorias",
        subcategories: "Subcategorias",
      },
      new_category: "Nova Categoria",
      new_subcategory: "Nova Subcategoria",
      selectCategory: "Selecione uma categoria",
    },
    locations: {
      title: "Localizações",
      subtitle: "Estrutura hierárquica de armazenamento",
      new: "Nova Localização",
      addSublocal: "+ Sublocal",
      inactivate: "Inativar",
      activate: "Ativar",
      confirmInactivate: "Inativar essa localização? Ela não aparecerá mais em seleções.",
      confirmActivate: "Reativar essa localização?",
      confirmDelete: "Excluir \"{{name}}\" definitivamente? Isso só funciona se não tiver sub-locais nem estoque apontando para ela — senão use inativar.",
      tree: { title: "Árvore de Locais" },
      field: {
        type: "Tipo",
        capacity: "Capacidade",
        children: "Sub-locais",
      },
      status: { active: "Ativa", inactive: "Inativa" },
      selectLocation: "Selecione uma localização",
      children: "Sub-locais",
      form: {
        newTitle: "Nova localização",
        editTitle: "Editar localização",
        name: "Nome",
        type: "Tipo",
        code: "Código",
        parent: "Localização pai",
        noParent: "— (sem pai, vira raiz)",
        parentHint: "Escolha o local que contém este. Deixe vazio para criar um local de topo (raiz).",
        notes: "Observações",
        isActive: "Ativa (aparece em seleções)",
        errorNameRequired: "O nome é obrigatório.",
      },
      type: {
        unit: "Unidade",
        room: "Sala",
        stock_area: "Área de estoque",
        shelf: "Prateleira",
        cabinet: "Armário",
        box: "Caixa",
        dispatch_area: "Expedição",
        external_storage: "Armazenamento externo",
      },
    },
    stock: {
      title: "Inventário",
      records: "registros de saldo",
      col: {
        item: "Item",
        location: "Localização",
        status: "Status",
      },
      available: "Disponível",
      reserved: "Reservado",
      damaged: "Danificado",
      total: "Total",
    },
    movements: {
      title: "Movimentações",
      records: "movimentações registradas",
      col: {
        type: "Tipo",
        item: "Item",
        qty: "Qtd.",
        from: "Origem",
        to: "Destino",
        justification: "Justificativa",
        date: "Data",
      },
      type: {
        entry: "Entrada",
        transfer: "Transferência",
        shipment_out: "Saída (envio)",
        offline_action_out: "Saída (ação offline)",
        return_in: "Devolução",
        loss: "Perda",
        damage: "Dano",
        inventory_adjustment: "Ajuste de inventário",
        write_off: "Baixa",
        reservation: "Reserva",
        reservation_release: "Liberação de reserva",
      },
    },
    recipients: {
      title: "Destinatários",
      registered: "destinatários cadastrados",
      new: "Novo Destinatário",
      viewTimeline: "Ver Timeline",
      timeline: "Timeline de interações",
      timelineEmpty: "Nenhum evento registrado",
      saleEventPrivate: "Informações financeiras restritas",
      selectPrompt: "Selecione um destinatário",
      selectPromptSub: "Escolha um contato na lista à esquerda para ver os detalhes",
      col: {
        name: "Nome",
        type: "Tipo",
        status: "Relacionamento",
        email: "Email",
        city: "Cidade",
        tags: "Tags",
        lastInteraction: "Última interação",
      },
      type: {
        institution: "Instituição",
        gallery: "Galeria",
        collector: "Colecionador",
        curator: "Curador",
        journalist: "Jornalista",
        artist: "Artista",
        client: "Cliente",
        press: "Imprensa",
        partner: "Parceiro",
        supplier: "Fornecedor",
        transport: "Transporte",
        service_provider: "Prestador de Serviço",
        internal_team: "Equipe Interna",
        art_advisor: "Art Advisor",
        architect: "Arquiteto(a)",
        decorator: "Decorador(a)",
        other: "Outro",
      },
      status: {
        lead: "Lead",
        prospect: "Prospect",
        customer: "Cliente",
        vip: "VIP",
        collector: "Colecionador",
        architect: "Arquiteto(a)",
        advisor: "Advisor",
        supplier: "Fornecedor",
        transport: "Transporte",
        service_provider: "Prestador de Serviço",
        imprensa: "Imprensa",
        curator: "Curador(a)",
        inactive: "Inativo",
      },
      tab: {
        contact: "Contato",
        observations: "Observações",
        preferences: "Preferências",
        lgpd: "LGPD",
        fiscal: "Dados Fiscais",
        timeline: "Timeline",
        lists: "Listas",
        lists_empty_title: "Este destinatário não está em nenhuma lista",
        lists_empty_desc: "Crie uma lista em Comercial → Listas e adicione este contato.",
        lists_static_title: "Listas estáticas",
        lists_static_empty: "Sem listas estáticas.",
        lists_dynamic_title: "Listas dinâmicas",
        lists_dynamic_empty: "Sem listas dinâmicas que capturem este contato.",
        shipments: "Envios",
        analytics: "Analytics",
        emails: "Emails",
      },
      section: {
        contact: "Informações de Contato",
        details: "Detalhes",
        metrics: "Métricas CRM",
        address: "Endereço",
        social: "Redes Sociais",
        communication: "Comunicação",
        fiscal: "Dados Fiscais",
        interests: "Preferências Artísticas",
        conversations: "Conversas",
        tags: "Tags",
        actions: "Ações Sugeridas",
      },
      field: {
        email: "Email",
        phone: "Telefone",
        city: "Cidade",
        state: "Estado",
        country: "País",
        role: "Cargo",
        lead_source: "Origem do Lead",
        classification: "Classificação",
        classifications: "Classificações",
        keywords: "Palavras-chave",
        notes: "Observações",
        address: "Endereço",
        district: "Bairro",
        postal_code: "CEP",
        company: "Empresa",
        birthday: "Aniversário",
        client_since: "Cliente desde",
        owner: "Responsável",
        channel: "Canal Preferido",
        instagram: "Instagram",
        linkedin: "LinkedIn",
        facebook: "Facebook",
        twitter: "Twitter / X",
        website: "Site Pessoal",
        external_id: "ID Externo",
        media_outlet_type: "Tipo de Veículo",
        document: "CPF / CNPJ",
      },
      lgpd: {
        title: "Consentimentos LGPD",
        subtitle: "Registre os canais autorizados pelo contato para comunicação.",
        email: "Email Marketing",
        whatsapp: "WhatsApp",
        sms: "SMS",
        phone: "Ligação Telefônica",
        mail: "Correspondência Física",
        consented_at: "Data do consentimento",
        legal: "Os consentimentos são armazenados em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018). Nunca envie comunicações sem consentimento registrado.",
        granted: "Autorizado",
        denied: "Não autorizado",
      },
      metric: {
        totalShipments: "Total de Envios",
        totalSalesCount: "Compras",
        itemsSent: "Itens Enviados",
        shipments12m: "Envios (12 meses)",
        interactions90d: "Interações (90 dias)",
        ltv: "LTV Total",
        avgTicket: "Ticket Médio",
        firstPurchase: "Primeira Compra",
        lastPurchase: "Última Compra",
        totalInteractions: "Interações",
      },
      meta: {
        created_at: "Cadastrado em",
        updated_at: "Atualizado em",
      },
      action: {
        edit: "Editar",
        registerInteraction: "Registrar Interação",
        newConversation: "Nova conversa",
        openConversations: "Ver conversas",
        viewTimeline: "Ver Timeline Completa",
        sendCatalog: "Enviar catálogo",
        inviteVernissage: "Convidar para vernissage",
        optOut: "Não perturbe",
        undoOptOut: "Remover opt-out",
      },
      optOut: {
        badge: "Não Perturbe",
        badgeSince: "Fora da lista desde {{date}}",
        confirmTitle: "Registrar opt-out",
        dateLabel: "Data do opt-out",
        confirmLabel: "Motivo (opcional)",
        confirmPlaceholder: "Ex: solicitou por e-mail, STOP no WhatsApp…",
        confirmButton: "Confirmar opt-out",
        undoConfirm: "Remover o opt-out deste contato?",
      },
      conversations: {
        empty: "Nenhuma conversa vinculada ainda.",
        noSubject: "Sem assunto",
        unassigned: "Sem responsável",
      },
      interaction: {
        title: "Registrar Interação",
        type: "Tipo de Interação",
        channel: "Canal",
        subject: "Assunto",
        notes: "Notas",
        date: "Data",
        save: "Salvar Interação",
        types: {
          visit: "Visita",
          email: "Email",
          whatsapp: "WhatsApp",
          phone: "Telefone",
          meeting: "Reunião",
          catalog_sent: "Catálogo Enviado",
          gift_sent: "Brinde Enviado",
          viewing_room_access: "Acesso Viewing Room",
          event_attended: "Presença em Evento",
          other: "Outro",
          opt_out: "Opt-out registrado",
          opt_out_removed: "Opt-out removido",
        },
      },
      editModal: {
        title: "Editar Destinatário",
        section: {
          personal: "Dados Pessoais",
          contact: "Contato",
          address: "Endereço",
          social: "Redes Sociais",
          crm: "CRM",
        },
      },
      filter: {
        all: "Todos",
        status: "Status",
        type: "Tipo",
        tag: "Tag",
        origin: "Origem",
      },
      shipments: {
        col: {
          date: "Data",
          number: "Número",
          items: "Itens",
          status: "Status",
          actions: "Ações",
        },
        empty: "Nenhum envio para este destinatário",
      },
      empty: "Nenhum destinatário encontrado",
    },
    shipments: {
      title: "Envios",
      registered: "envios registrados",
      searchPlaceholder: "Buscar por nº do envio, destinatário, obra ou rastreio",
      dateFrom: "De",
      dateTo: "Até",
      clearFilters: "Limpar filtros",
      exportReport: "Exportar relatório",
      exporting: "Gerando...",
      exportError: "Não foi possível gerar o relatório.",
      new: "Novo Envio",
      recipient: "Destinatário",
      method: "Método",
      items: "Itens",
      status: "Status",
      tracking: "Rastreio",
      date: "Data",
      confirm: "Confirmar Envio",
      addItem: "Adicionar Item",
      step: {
        header: "Cabeçalho",
        items: "Itens",
        confirm: "Confirmação",
      },
      field: {
        recipient: "Destinatário",
        method: "Método de envio",
        weight: "Peso total (kg)",
        weightHint: "Usado na Declaração de Conteúdo dos Correios.",
        notes: "Observações",
        item: "Item",
        location: "Localização",
        qty: "Quantidade",
      },
      statusValue: {
        pending: "Pendente",
        separated: "Separado",
        dispatched: "Enviado",
        delivered: "Entregue",
        returned: "Devolvido",
        lost: "Extraviado",
        cancelled: "Cancelado",
      },
      methodValue: {
        courier: "Transportadora",
        correios: "Correios",
        transport_company: "Empresa de Motoboy",
        hand_delivery: "Entrega em mãos",
        pickup: "Retirada",
        internal_delivery: "Entrega interna",
      },
      declaracao: {
        button: "Declaração de Conteúdo",
        title: "Declaração de Conteúdo",
        sender: "Remetente",
        recipient: "Destinatário",
        senderSource: "Remetente",
        senderGallery: "Galeria (padrão)",
        senderOther: "Outro (destinatário cadastrado)",
        selectSender: "Selecione o remetente…",
        goods: "Identificação dos bens",
        colItem: "Item",
        colContent: "Conteúdo",
        colQty: "Quantidade",
        colValue: "Valor",
        totals: "Totais",
        totalWeight: "Peso total (kg)",
        name: "Nome",
        address: "Endereço",
        city: "Cidade",
        state: "UF",
        postalCode: "CEP",
        document: "CNPJ/CPF",
        print: "Imprimir / Salvar PDF",
        legal:
          "Declaro que não me enquadro no conceito de contribuinte previsto no art. 4º da Lei Complementar nº 87/1996, uma vez que não realizo, com habitualidade ou em volume que caracterize intuito comercial, operações de circulação de mercadoria, ainda que se iniciem no exterior, ou estou dispensado da emissão da nota fiscal por força da legislação tributária vigente, responsabilizando-me, nos termos da lei e a quem de direito, por informações inverídicas. Declaro ainda que não estou postando conteúdo inflamável, explosivo, causador de combustão espontânea, tóxico, corrosivo, gás ou qualquer outro conteúdo que constitua perigo, conforme o art. 13 da Lei Postal nº 6.538/78.",
        observation:
          "OBSERVAÇÃO: Constitui crime contra a ordem tributária suprimir ou reduzir tributo, ou contribuição social e qualquer acessório (Lei 8.137/90 Art. 1º, V).",
        signature: "Assinatura do Declarante/Remetente",
      },
    },
    conversations: {
      title: "Conversas",
      registered: "conversas registradas",
      new: "Nova Conversa",
      messages: "Mensagens",
      messageTimeline: "Histórico da conversa",
      selectPrompt: "Selecione uma conversa",
      selectPromptSub: "Escolha uma conversa na lista à esquerda para ver os detalhes",
      empty: "Nenhuma conversa encontrada",
      emptyMessage: "Crie a primeira conversa para começar o acompanhamento relacional.",
      emptyMessages: "Nenhuma mensagem registrada ainda.",
      filteredRecipient: "Destinatário em foco",
      clearRecipientFilter: "Limpar filtro",
      searchPlaceholder: "Buscar por assunto, destinatário ou responsável",
      emptyFilteredMessage: "Nenhuma conversa encontrada com os filtros atuais.",
      filter: {
        allAssignees: "Todos os responsáveis",
      },
      sort: {
        updatedDesc: "Mais recentes primeiro",
        updatedAsc: "Mais antigas primeiro",
        recipientAsc: "Destinatário (A-Z)",
      },
      field: {
        recipient: "Destinatário",
        assignee: "Responsável",
        status: "Status",
        subject: "Assunto",
        direction: "Direção",
        content: "Mensagem",
        createdBy: "Criado por",
        createdAt: "Criado em",
        updatedAt: "Atualizado em",
      },
      status: {
        open: "Aberta",
        in_progress: "Em andamento",
        closed: "Fechada",
      },
      direction: {
        inbound: "Entrada",
        outbound: "Saída",
        internal: "Interna",
        system: "Sistema",
      },
      saveSuccess: "Conversa atualizada.",
      createSuccess: "Conversa criada.",
      messageCreateSuccess: "Mensagem registrada.",
      messageUpdateSuccess: "Mensagem atualizada.",
      messageDeleteSuccess: "Mensagem excluída do histórico visível.",
      messageDeleteConfirm: "Excluir esta mensagem do histórico visível?",
      addMessage: "Registrar mensagem",
      sendMessage: "Salvar mensagem",
      editMessage: "Editar mensagem",
      deleteMessage: "Excluir mensagem",
    },
    kits: {
      title: "Kits",
      new: "Novo Kit",
    },
    galleryConfig: {
      title: "Configuração da Galeria",
      subtitle:
        "Dados usados em PDFs e na Declaração de Conteúdo dos Correios (remetente, banco).",
      saved: "Alterações salvas.",
    },
    offlineActions: {
      title: "Ações Offline",
      registered: "ações registradas",
      new: "Nova ação",
      edit: "Editar ação",
      back: "Ações offline",
      empty: "Nenhuma ação registrada ainda.",
      col: {
        name: "Nome",
        status: "Status",
        location: "Local",
        dates: "Período",
        responsible: "Responsável",
      },
      filter: { all: "Todos os status" },
      type: {
        gifting: "Brindes",
        relationship: "Relacionamento",
        institutional_shipping: "Envio institucional",
        fair_support: "Apoio a feira",
        press: "Imprensa",
        year_end_action: "Ação de fim de ano",
        special_campaign: "Campanha especial",
        other: "Outra",
      },
      status: {
        planned: "Planejada",
        active: "Em andamento",
        finished: "Encerrada",
        cancelled: "Cancelada",
      },
      actions: { active: "Iniciar", finished: "Encerrar", cancelled: "Cancelar ação" },
      form: {
        name: "Nome",
        type: "Tipo",
        responsible: "Responsável",
        startDate: "Início",
        endDate: "Fim",
        campaign: "Campanha",
        description: "Descrição",
      },
      tabs: {
        lista: "Lista",
        lotes: "Lotes e separação",
        rotas: "Rotas e entrega",
        acompanhamento: "Acompanhamento",
        soon: "em breve",
      },
      header: {
        responsible: "responsável",
        costs: "Configurar custos",
        exportSheet: "Exportar planilha",
        pickingList: "Lista de separação",
      },
      planejados: {
        empty: "Nenhum item ou kit planejado nesta ação.",
        item: "Item / kit",
        planned: "Planejado",
        used: "Usado",
        hint: "Os itens planejados vêm do cadastro da ação. O que cada pessoa recebe fica na aba Lista.",
      },
      lista: {
        card: {
          pessoas: "Pessoas",
          pessoasSub: "{{brindes}} brindes · {{semBrinde}} sem brinde",
          ok: "Endereço ok",
          okSub: "com CEP e número",
          confirmar: "Confirmar",
          confirmarSub: "sem CEP ou aproximado",
          semEndereco: "Sem endereço",
          semEnderecoSub: "pedir à equipe",
          foraSp: "Fora de SP",
          foraSpSub: "vão por Correios",
          retira: "Retirada / em mãos",
          retiraSub: "artistas e equipe",
        },
        crmFiltersHint: "Filtros do CRM (classificação · comprou nos últimos 3 anos · VIP · recebeu em 2025): em breve, na fase 2.",
        corrigir: "corrigir",
        vai: {
          ok: "ok",
          confirmar: "confirmar",
          sem_endereco: "sem endereço",
          fora_sp: "fora de SP → Correios",
          retira: "retira na galeria",
          nao_checado: "não checado",
        },
        hint: {
          semEndereco: "sem endereço no CRM",
          confirmar: "Google leu: {{google}}",
          foraSp: "{{cidade}} · vai por Correios",
          retira: "não entra em lote",
        },
        legend: {
          ok: "geocodificado no número",
          confirmar: "Google achou só a rua ou o bairro",
          sem_endereco: "fica fora dos lotes até resolver",
          fora_sp: "vai para Correios automaticamente",
          retira: "artistas e equipe",
        },
        kpi: {
          total: "Na lista",
          ok: "Endereço OK",
          conferir: "Conferir",
          semEndereco: "Sem endereço",
          foraSp: "Fora de SP",
          semBrinde: "Sem brinde",
          envios: "Envios gerados",
          naoChecado: "{{count}} endereço(s) ainda não checado(s) no Google — clique em “Checar endereços”.",
          brindesTotal: "{{count}} brindes",
        },
        btn: {
          crm: "do CRM",
          list: "de uma lista",
          sheet: "Importar planilha",
          geocode: "Checar endereços",
          bulkGift: "Brinde para todos",
          pdf: "PDF de separação",
          ship: "Gerar envios ({{count}})",
        },
        search: "Buscar por nome…",
        showing: "{{shown}} de {{total}}",
        empty: "A lista está vazia. Adicione pessoas do CRM, de uma lista de destinatários ou importe a planilha da equipe.",
        noGift: "sem brinde",
        col: {
          name: "Nome",
          pessoa: "Pessoa",
          brinde: "Brinde · variação",
          qtd: "Qtd",
          vai: "Vai",
          gift: "Brinde",
          address: "Endereço de entrega",
          shipment: "Envio",
          category: "Categoria",
          responsible: "Responsável (equipe)",
          notes: "Observações",
        },
        source: { crm: "CRM", list: "lista", sheet: "planilha", manual: "manual" },
        semaforo: {
          ok: "OK",
          conferir: "Conferir",
          falhou: "Não achou",
          sem_endereco: "Sem endereço",
          nao_checado: "Não checado",
        },
        geo: {
          done: "Checados {{checked}}: {{ok}} OK, {{conferir}} para conferir, {{falhou}} não encontrados. Pulados: {{skipped_no_address}} sem endereço, {{skipped_already}} já checados.",
        },
        addDone: "{{added}} adicionado(s); {{already_in_list}} já estava(m) na lista.",
        addCrm: {
          title: "Adicionar do CRM",
          submit: "Adicionar {{count}}",
          search: "Destinatário",
          searchHint: "Digite o nome (mínimo 2 letras)…",
          empty: "Ninguém encontrado com esse nome.",
        },
        addList: {
          title: "Adicionar de uma lista de destinatários",
          submit: "Adicionar todos da lista",
          list: "Lista",
          hint: "Quem já estiver na lista de brindes não entra de novo.",
        },
        sheet: {
          title: "Importar planilha da equipe",
          intro: "Use a planilha como a equipe monta (colunas como Nome, Endereço, QNT, TAM, Categoria, OBS, em qualquer ordem). Primeiro mostramos a prévia com o casamento dos nomes com o CRM; nada é gravado até você confirmar.",
          preview: "Ver prévia",
          back: "Trocar arquivo",
          confirm: "Adicionar {{count}} à lista",
          counts: "{{use}} do cadastro · {{create}} novos cadastros · {{skip}} ignorados",
          giftDefault: "Brinde para todas as linhas",
          giftDefaultHint: "Quantidade e tamanho vêm de cada linha da planilha.",
          addressPolicy: "Endereço da planilha",
          addressAuto: "Gravar só para quem não tem endereço no cadastro",
          addressAlways: "Gravar sempre como novo endereço (e usar na entrega)",
          addressNever: "Ignorar; usar o endereço do cadastro",
          colName: "Nome na planilha",
          colGift: "Qtd / tam.",
          colAddress: "Endereço na planilha",
          colMatch: "No CRM",
          colDecision: "O que fazer",
          match: {
            exata: "Encontrado",
            provavel: "Provável",
            possivel: "Parecido",
            nenhuma: "Não encontrado",
            ja_na_lista: "Já na lista",
          },
          useCandidate: "Usar: {{name}} ({{extra}})",
          noAddress: "sem endereço",
          createNew: "Criar cadastro novo",
          skipRow: "Ignorar esta linha",
          done: "{{added}} adicionado(s), {{created_recipients}} cadastro(s) novo(s), {{addresses_created}} endereço(s) criado(s). {{already_in_list}} já estava(m) na lista; {{skipped}} ignorado(s).",
        },
        edit: {
          address: "Endereço para esta entrega",
          addressPrimary: "Principal do cadastro",
          addressHint: "Para corrigir ou cadastrar um endereço, abra o destinatário.",
          openRecipient: "Abrir destinatário",
          googleRead: "Como o Google leu",
          pickup: "Retira na galeria / recebe em mãos",
          pickupHint: "Artistas e equipe: fica fora dos lotes e das rotas.",
        },
        ship: {
          title: "Gerar envios",
          intro: "Cria um envio pendente para cada pessoa da lista que tem brinde definido e ainda não tem envio. Nada sai do estoque agora: a baixa acontece quando o envio for confirmado em Envios.",
          method: "Meio de envio",
          methodHint: "Pode ser trocado depois, envio a envio. Na fase 2 o meio vem do lote.",
          submit: "Gerar {{count}} envio(s)",
          done: "{{count}} envio(s) criado(s), pendente(s).",
          note: "Até a fase 2 (lotes e rotas), os envios podem ser gerados direto da lista: um envio pendente por pessoa com brinde definido.",
        },
        bulk: {
          title: "Brinde para todos sem brinde",
          intro: "Define o mesmo brinde para todas as pessoas da lista que ainda estão sem brinde.",
          submit: "Aplicar a {{count}} sem brinde",
          done: "Brinde definido em {{count}} linha(s).",
        },
        remove: {
          title: "Tirar da lista",
          message: "Tirar {{name}} da lista de brindes? O cadastro no CRM não muda.",
        },
        gift: {
          item: "Item",
          kit: "Kit",
          none: "— a definir —",
          quantity: "Quantidade",
          variation: "Tamanho / variação",
          variationHint: "ex.: 37, 41/43",
        },
      },
    },
    audit: {
      title: "Auditoria",
      records: "registros",
      detail: "Detalhes do Registro",
      selectLog: "Selecione um registro para ver detalhes",
      col: {
        action: "Ação",
        table: "Tabela",
        record: "Registro",
        user: "Usuário",
        date: "Data",
      },
    },
    users: {
      title: "Usuários",
      registered: "usuários",
      col: {
        name: "Nome",
        email: "Email",
        roles: "Perfis",
        status: "Status",
        created: "Cadastro",
      },
    },
    imports: {
      title: "Importar Dados",
      subtitle: "Upload de planilhas de clientes e vendas",
      upload: "Upload de Arquivo",
      preview: "Pré-visualização",
      history: "Histórico de Importações",
      type: { clients: "Clientes", sales: "Vendas" },
      col: {
        file: "Arquivo",
        status: "Status",
        rows: "Linhas",
        user: "Usuário",
        date: "Data",
      },
      rowsDetected: "linhas detectadas",
      columns: "colunas",
      dropzone: {
        title: "Arraste um arquivo aqui ou clique para selecionar",
        formats: "CSV, XLSX, XLS",
      },
      step: {
        upload: "Upload",
        preview: "Preview",
        importing: "Importando",
        done: "Concluído",
      },
      analyze: "Analisar arquivo",
      analyzing: "Analisando...",
      confirmImport: "Confirmar importação",
      importingMessage: "Importando {{count}} registros... Isso pode levar alguns minutos.",
      elapsed: "Tempo decorrido",
      resultSuccess: "Importação concluída com sucesso",
      resultError: "Importação concluída com erros",
      totalProcessed: "Total processado",
      success: "Sucesso",
      errors: "Erros",
      totalTime: "Tempo total",
      viewErrors: "Ver detalhes dos erros",
      downloadErrors: "Baixar erros (XLSX)",
      errorsTruncated: "Mostrando {{shown}} de {{total}} erros. Baixe o XLSX para ver todos.",
      errorsDrawer: {
        title: "Erros da importação",
        entries: "erros",
        searchPlaceholder: "Buscar por linha, ID ou mensagem...",
        row: "Linha",
        externalId: "ID externo",
        message: "Mensagem",
        noErrors: "Esta importação não tem erros registrados.",
      },
      importAnother: "Importar outro arquivo",
      viewRecipients: "Ver Destinatários",
      mapping: "Mapeamento de colunas",
      rollback: "Rollback",
      rollbackConfirm: "Tem certeza que deseja reverter esta importação?",
      rollbackTitle: "Reverter importação",
      status: {
        completed: "Concluído",
        failed: "Falhou",
        processing: "Processando",
        pending: "Pendente",
        rolled_back: "Revertido",
      },
    },
    pedidos: {
      title: "Pedidos",
      new: "Novo Pedido",
      importTango: "Importar Tango",
      export: "Exportar",
      allCiclos: "Todos os ciclos",
      statusLabel: {
        0: "Cancelado",
        1: "Aberto",
        2: "Fechado",
        3: "Finalizado",
      },
      cicloLabel: {
        venda: "Venda",
        consignacao: "Consignação",
        feira: "Feira/Expo",
        emprestimo: "Empréstimo",
        restauro: "Restauro",
        compra: "Compra",
        doacao: "Doação",
        outro: "Outro",
      },
      stageLabel: {
        interesse: "Interesse",
        viewing: "Viewing",
        proposta: "Proposta",
        reserva: "Reserva",
        fechado: "Fechado",
        perdido: "Perdido",
      },
      col: {
        pedido: "Pedido",
        tipo: "Tipo",
        data: "Data",
        cliente: "Cliente",
        obras: "Obras",
        valor: "Valor",
        status: "Status",
      },
      kpi: {
        total: "Total",
        abertos: "Abertos",
        fechados: "Fechados",
        finalizados: "Finalizados",
        volHistorico: "Vol. Histórico",
        reservas: "Reservas",
      },
      tab: {
        todos: "Todos",
        aberto: "Aberto",
        fechado: "Fechado",
        finalizado: "Finalizado",
        cancelado: "Cancelado",
      },
      obras: "Obras do Pedido",
      financeiro: "Financeiro",
      noObras: "Sem obras registradas.",
      noData: "Nenhum pedido encontrado.",
      loading: "Carregando pedidos…",
      selectToView: "Selecione um pedido para ver os detalhes.",
      reservaExpiry: "Reserva vence em {{days}}d",
      reservaExpired: "Reserva vencida",
      reservaExpiresToday: "Reserva vence hoje",
    },
  },
};

const en = {
  translation: {
    app: {
      subtitle: "Collection Control",
      systemOnline: "System online",
      internalUse: "internal use",
    },
    nav: {
      dashboard: "Dashboard",
      gerencial: "Management Dashboard",
      projects: "Projects",
      artworks: "Artworks",
      artworkLists: "Artwork Lists",
      artists: "Artists",
      catalogs: "Catalogs",
      catalogsPipeline: "Catalogs in pipeline",
      catalogsTracking: "Delivery tracking",
      mediaAssets: "Media Library",
      items: "Items",
      categories: "Categories",
      locations: "Locations",
      stock: "Inventory",
      movements: "Movements",
      recipients: "Recipients",
      recipient_lists: "Lists",
      conversations: "Conversations",
      pipeline: "Pipeline",
      leads: "Leads",
      pedidos: "Orders",
      shipments: "Shipments",
      kits: "Kits",
      offlineActions: "Offline Actions",
      reports: "Reports",
      audit: "Audit",
      imports: "Import Data",
      users: "Users",
      galleryConfig: "Gallery Settings",
      timeline: "Timeline",
      financeiroVisaoGeral: "Overview",
      financeiroReceber: "Receivables",
      financeiroPagar: "Payables",
      financeiroRepasses: "Artist Payments",
      financeiroConciliacao: "Bank Reconciliation",
      financeiroCadastros: "Registries",
      financeiroDevSistema: "System Development",
      comunicacaoCampanhas: "Campaigns",
      comunicacaoConteudos: "Content",
      comunicacaoAtividades: "Activities",
      comunicacaoKanban: "Kanban",
      comunicacaoCalendario: "Calendar",
      comunicacaoCalendarioEditorial: "Editorial Calendar",
      comunicacaoDashboard: "Dashboard",
      comunicacaoAprovacoes: "Approvals",
      comunicacaoAssets: "Asset Library",
      comunicacaoSimulacao: "Instagram Simulation",
      comunicacaoMetricas: "Metrics",
      comunicacaoContatosImprensa: "Press Contacts",
      comunicacaoPressReleases: "Press Releases",
      campanhasEmail: "Email Campaigns",
      group: {
        overview: "Overview",
        catalog: "Catalog",
        stock: "Stock",
        comercial: "Commercial",
        campaigns: "Campaigns",
        financeiro: "Finance",
        comunicacao: "Communication",
        reports: "Reports",
        admin: "Admin",
      },
    },
    comunicacao: {
      campanhas: "Campaigns",
      novaCampanha: "New campaign",
      editarCampanha: "Edit campaign",
      definirCapa: "Set/change main image",
      urlImagemPlaceholder: "Paste an image URL (https://...)",
      usarUrl: "Use URL",
      novoConteudo: "New content",
      semCampanhas: "No campaigns yet.",
      emBreve: "coming soon (next phase)",
      conteudos: "Content",
      editarConteudo: "Edit content",
      semConteudos: "No content yet.",
      semCampanha: "No campaign",
      registrarPublicacao: "Log publication",
      checklistPublicacao: "Publication checklist",
      novoItemChecklist: "Add checklist item…",
      removerItemChecklist: "Remove item",
      aprovacao: "Approval",
      aprovar: "Approve",
      reprovar: "Reject",
      solicitarAjuste: "Request changes",
      comentarioAprovacao: "Comment (required to reject/request changes)",
      comentarioObrigatorio:
        "A comment is required to reject or request changes.",
      historicoAprovacao: "Approval history",
      comentarios: "Comments",
      semComentarios: "No comments yet.",
      escreverComentario: "Write a comment...",
      comentar: "Comment",
      detalhes: "Details",
      assetsVinculados: "Linked assets",
      atividadesGeradas: "Generated activities",
      metricasRegistradas: "Recorded metrics",
      campoConteudo: {
        titulo: "Internal title",
        campanha: "Campaign",
        canal: "Channel",
        formato: "Format",
        pilar: "Content pillar",
        dataPrevista: "Planned date",
        publicadoEm: "Published at",
        status: "Status",
        legenda: "Caption",
        altText: "Alt text",
        hashtags: "Hashtags",
        link: "Destination link",
      },
      contentStatus: {
        ideia: "Idea",
        pendente: "Pending",
        em_producao: "In production",
        aguardando_material: "Awaiting material",
        texto_em_revisao: "Copy in review",
        design_em_revisao: "Design in review",
        aguardando_aprovacao: "Awaiting approval",
        ajustes_solicitados: "Changes requested",
        aprovado: "Approved",
        agendado: "Scheduled",
        publicado: "Published",
        metricas_pendentes: "Metrics pending",
        concluido: "Done",
        cancelado: "Cancelled",
        gaveta: "Drawer",
      },
      atividades: "Activities",
      novaAtividade: "New activity",
      editarAtividade: "Edit activity",
      semAtividades: "No activities yet.",
      semItensCalendario: "Nothing in this period with these filters.",
      concluir: "Complete",
      checklist: "Checklist",
      semChecklist: "No checklist items.",
      adicionarItem: "Add item...",
      adicionar: "Add",
      anexos: "Attachments",
      apenasAtrasadas: "Overdue only",
      apenasAprovacoesPendentes: "Pending approvals only",
      apenasMinhas: "Mine only",
      kanban: "Production Kanban",
      kanbanDica: "Drag cards between columns to change status",
      kanbanMode: { content: "Content", activity: "Activities" },
      calendario: "Activity Calendar",
      hoje: "Today",
      canais: {
        cores: "Channel colors",
        coresDica: "The color and name chosen here appear on the channel tags of the calendars, for the whole team.",
        rotulo: "Channel name",
        cor: "Color",
        todos: "All channels",
      },
      view: {
        mes: "Month",
        semana: "Week",
        lista: "List",
        porCanal: "By channel",
      },
      editorial: {
        titulo: "Editorial Calendar",
        subtitulo: "The gallery's publishing schedule, organized by channel.",
        stats: "{{count}} scheduled publications · {{canais}} channels",
        filtroCanais: "All channels",
        filtroCampanhas: "All campaigns",
        filtroArtistas: "All artists / exhibitions",
        filtroStatus: "All statuses",
        previaPorCanal: "Preview — By Channel",
        vistaCompleta: 'full view in "By Channel"',
        legenda: "Legend",
        canaisLabel: "Channels",
        statusLabel: "Status",
        semPublicacoes: "No publications in this period with these filters.",
        bucketProducao: "In production",
        bucketAgendado: "Scheduled",
        bucketPublicado: "Published",
        semCanal: "No publications on this channel",
      },
      dashboard: "Dashboard",
      aprovacoes: "Approvals",
      pendentes: "pending",
      semAprovacoesPendentes: "No pending approvals.",
      somenteAprovadorAge: "Only approvers can act here.",
      naFilaDias: "in queue {{count}}d",
      naFilaHoras: "in queue {{count}}h",
      naFilaAgora: "just queued",
      semResultadosFiltro: "No items match these filters.",
      aprovFiltro: {
        all: "All",
        content: "Content",
        activity: "Activities",
        campanhaTodas: "Campaign: all",
        canalTodos: "Channel: all",
        prioridadeTodas: "Priority: all",
      },
      aprovSort: {
        queue_old: "Longest in queue",
        queue_new: "Newest in queue",
        planned: "By planned date",
        priority: "By priority",
      },
      entidade: {
        content: "Content",
        activity: "Activity",
      },
      kpi: {
        campanhasAtivas: "Active campaigns",
        conteudosProducao: "Content in production",
        atividadesAbertas: "Open activities",
        atrasadas: "Overdue",
        aguardandoAprovacao: "Awaiting approval",
        aprovados: "Approved",
        agendados: "Scheduled",
        publicadosMes: "Published this month",
        metricasPendentes: "Metrics pending",
        assetsPendentes: "Assets pending",
      },
      grafico: {
        conteudosPorStatus: "Content by status",
        atividadesPorStatus: "Activities by status",
        publicacoesPorCanal: "Publications by channel",
      },
      instagram: {
        titulo: "Instagram",
        atualizado: "updated on",
        seguidores: "Followers",
        em30dias: "in the last 30 days",
        alcance30d: "Reach (30d)",
        interacoes30d: "Interactions (30d)",
        visitasPerfil30d: "Profile visits (30d)",
        cliquesSite30d: "Website clicks (30d)",
        alcanceDiario: "Daily reach",
      },
      instagramPost: {
        titulo: "Instagram metrics",
        vincular: "Link",
        revincular: "Re-link",
        vinculado: "Post linked to Instagram.",
        puxar: "Pull metrics from Instagram",
        coletado: "Metrics pulled from Instagram.",
        ajuda: "Paste the published post link to pull metrics automatically.",
      },
      contentStories: {
        titulo: "Instagram stories",
        selecionar: "Select stories",
        alterar: "Change selection",
        ajudaSelecao:
          "Check the stories that belong to this content. One content may have several.",
        ajudaVazio:
          "Stories have no post link: pick from the collected stories below to see their combined metrics here.",
        semColetadas: "No stories collected yet. Collection runs hourly.",
        jaEmOutro: "Already linked to another content",
        selecionadas: "{{count}} selected",
        views: "views",
        alcance: "reach",
        interacoes: "interactions",
        respostas: "replies",
        notaSoma:
          "Sum of the selected stories. Collection refreshes hourly while the story is live.",
        erroSalvar: "Could not save the stories.",
        erroCarregar: "Could not load the stories.",
      },
      bancoAssets: "Asset Library",
      novoAsset: "New asset",
      editarAsset: "Edit asset",
      semAssets: "No assets yet.",
      selecionarArquivo: "Select file",
      selecionarArquivos: "Select files",
      uploadOuUrl: "Upload a file or provide an external URL below",
      uploadArquivo: "Choose one or more files to upload",
      uploadArquivosInvalidos: "There are invalid files in the list. Remove them or change the type before uploading.",
      uploadFalhasParciais: "{{count}} file(s) failed to upload and remain in the list. Try again.",
      nomeLoteHint: "With multiple files, each asset is named after its own file.",
      assetSource: { file: "File", url: "External URL", list: "Artwork list" },
      vincularLista: "Link an artwork list",
      selecioneLista: "Select a list…",
      verLista: "Open list",
      enviando: "Uploading...",
      enviandoPct: "Uploading… {{pct}}%",
      enviandoLote: "Uploading file {{atual}} of {{total}}… {{pct}}%",
      baixarAsset: "Download original file",
      expandirMidia: "Expand media",
      igSpecsHint: "Instagram specs: photo up to 30 MB (JPEG/PNG); video MP4/MOV — Story up to 60s, Feed up to 60 min.",
      igValidation: {
        imageFormat: "Image format not accepted by Instagram (use JPEG, PNG or WEBP).",
        imageSize: "Image exceeds Instagram's limit ({{max}} MB).",
        videoFormat: "Video format not accepted by Instagram (use MP4 or MOV).",
        videoSize: "Video exceeds Instagram's limit ({{max}} GB).",
        storyDuration: "Story video can't exceed 60s (yours is {{actual}}).",
        feedDuration: "Video can't exceed 60 min (yours is {{actual}}).",
        docSize: "File exceeds the limit ({{max}} MB).",
      },
      confirmarExcluirAsset: "Delete this asset?",
      campoAsset: {
        nome: "Asset name",
        tipo: "Type",
        direitoUso: "Usage rights",
        status: "Status",
        credito: "Image credit",
        urlExterna: "External URL",
        caminhoStorage: "Storage path",
        urlPublica: "Public URL",
        campanha: "Campaign",
      },
      assetType: {
        imagem_original: "Original image",
        imagem_tratada: "Edited image",
        video: "Video",
        arte_final: "Final art",
        story: "Story",
        carrossel: "Carousel",
        texto: "Text",
        release: "Release",
        press_kit: "Press kit",
        catalogo: "Catalog",
        pdf: "PDF",
        logo: "Logo",
        convite: "Invitation",
        foto_exposicao: "Exhibition photo",
        foto_obra: "Artwork photo",
        foto_artista: "Artist photo",
        foto_bastidor: "Behind-the-scenes photo",
      },
      assetStatus: {
        recebido: "Received",
        em_tratamento: "In processing",
        em_revisao: "In review",
        aprovado_para_uso: "Approved for use",
        uso_restrito: "Restricted use",
        publicado: "Published",
        arquivado: "Archived",
        nao_usar: "Do not use",
      },
      usageRights: {
        autorizado: "Authorized",
        pendente: "Pending",
        restrito: "Restricted",
        uso_interno: "Internal use",
        imprensa: "Press",
        redes_sociais: "Social media",
        nao_usar: "Do not use",
      },
      excluir: "Delete",
      confirmarExclusao: "Are you sure you want to delete? This action cannot be undone.",
      recados: "Notes / Post-its",
      semRecados: "No notes yet.",
      novoRecado: "Write a note...",
      adicionarRecado: "Add note",
      flutuar: "Float",
      compartilhar: "Share",
      privado: "Private",
      vincular: "Link",
      vincularAsset: "Link asset",
      desvincular: "Unlink",
      semAssetsVinculados: "No linked assets.",
      semAnexos: "No attachments.",
      registrarMetrica: "Log metric",
      metricaSoPublicado: "Metrics become available after the content is published.",
      semMetricas: "No metrics recorded yet.",
      metricaAtual: "current",
      dataColeta: "Collection date",
      metricasConsolidadasNota:
        "Consolidated from the latest collection of each published content in the campaign.",
      simulacaoInstagram: "Instagram Simulation",
      previewNaoPublica: "Preview — does not publish to Instagram",
      telaCheia: "Fullscreen",
      conteudoSimulado: "Content being simulated",
      temaEscuro: "Dark theme",
      abrirDetalheConteudo: "Open content detail",
      simSemImagem: "This content has no media yet (image or video).",
      simAdicionarImagem: "Add an asset",
      simMode: {
        post: "Post",
        grade: "Profile grid",
      },
      sim: {
        subtitulo: "See the piece as it will appear on Instagram — for review and approval, before posting.",
        visualizacao: "View",
        gradeExplica: "The grid inserts the new post in the 1st slot of the real @galerialeme profile (yellow outline) — to check the feed's visual harmony before approving.",
        tema: "Preview theme",
        tema_claro: "Light",
        tema_escuro: "Dark",
        metadados: "Metadata",
        publicacaoPrevista: "Scheduled for",
        responsavelTexto: "Owner (copy)",
        design: "Design",
        aprovadora: "Approver",
        legenda: "Caption",
        caracteres: "characters",
        verChecklistCompleta: "View full checklist ({{count}} items)",
        aprovacaoTitulo: "Approval",
        aguardandoAprovacao: "Awaiting approval from {{name}}.",
        semAprovacaoPendente: "No pending approval for this content.",
        verNaFila: "Open Approvals queue",
        outrosFormatos: "Other formats (static preview — Feed is the complete one)",
        rodape: "Local simulation, for visual review and approval only. No data is sent to Instagram — publishing is still scheduled in the external tool (content checklist).",
      },
      campoAtividade: {
        titulo: "Title",
        tipo: "Type",
        status: "Status",
        prioridade: "Priority",
        inicio: "Start",
        prazo: "Due",
        campanha: "Campaign",
        conteudo: "Content",
        responsavel: "Owner",
        descricao: "Description",
      },
      activityStatus: {
        pendente: "Pending",
        em_producao: "In production",
        aguardando_material: "Awaiting material",
        em_revisao: "In review",
        aguardando_aprovacao: "Awaiting approval",
        ajustes_solicitados: "Changes requested",
        aprovado: "Approved",
        agendado: "Scheduled",
        publicado: "Published",
        metricas_pendentes: "Metrics pending",
        concluido: "Done",
        cancelado: "Cancelled",
        gaveta: "Drawer",
      },
      activityType: {
        producao_texto: "Copywriting",
        producao_design: "Design production",
        revisao: "Review",
        aprovacao: "Approval",
        publicacao: "Publishing",
        agendamento: "Scheduling",
        envio_newsletter: "Newsletter send",
        release_imprensa: "Press release",
        cobertura_evento: "Event coverage",
        captacao_imagem: "Image capture",
        edicao_video: "Video editing",
        coleta_metricas: "Metrics collection",
        reuniao_pauta: "Editorial meeting",
        follow_up: "Follow-up",
        administrativa: "Administrative",
        outra: "Other",
      },
      priority: {
        baixa: "Low",
        media: "Medium",
        alta: "High",
        urgente: "Urgent",
      },
      equipeDetalhes: "Team & details",
      campo: {
        nome: "Campaign name",
        tipo: "Type",
        objetivo: "Objective",
        publicoAlvo: "Target audience",
        mensagemPrincipal: "Main message",
        status: "Status",
        dataInicio: "Start date",
        dataFim: "End date",
        evento: "Event",
        responsavel: "Owner",
        canais: "Channels",
        linkPrincipal: "Main link",
        descricao: "Description",
        observacoes: "Notes",
      },
      status: {
        planejamento: "Planning",
        em_producao: "In production",
        em_aprovacao: "In approval",
        ativa: "Active",
        encerrada: "Closed",
        arquivada: "Archived",
        cancelada: "Cancelled",
      },
      aba: {
        visaoGeral: "Overview",
        conteudos: "Content",
        atividades: "Activities",
        assets: "Assets",
        metricas: "Metrics",
      },
      contadores: {
        conteudos: "Content",
        atividades: "Activities",
        atividadesAbertas: "Open activities",
        atrasadas: "Overdue",
        aguardandoAprovacao: "Awaiting approval",
        diasAteAbertura: "Days to opening",
      },
      metricas: {
        titulo: "Metrics",
        subtitulo: "Communication channels performance",
        canalInstagram: "Instagram",
        canalSite: "Site · GA4",
        canalNewsletter: "Newsletter · Mailchimp",
        emBreve: "Phase 2",
        abaConta: "Account & Audience",
        abaPosts: "Posts",
        abaStories: "Stories",
        postsEmBreve: "Per-post metrics arrive next phase.",
        erroCarregarTitulo: "Could not load metrics",
        erroCarregar: "Could not load metrics. Please try again.",
        noPeriodo: "in the period",
        semSerie: "No series in the period.",
        canalAriaLabel: "Channel",
        fonte: {
          conta: "Source: BigQuery · updated daily",
          posts: "Source: Instagram Graph API · live data",
          stories: "Source: Instagram Graph API · collected hourly · no historical backfill",
          newsletter: "Source: Mailchimp · manually synced data",
        },
        site: {
          fonte: "Source: galerialeme.com GA4 · daily export to BigQuery · data until {{fim}}",
          abaVisaoGeral: "Overview",
          abaPaginas: "Pages",
          periodo7: "7 days",
          periodo30: "30 days",
          periodo90: "90 days",
          periodoAria: "Period",
          avisoTitulo: "Real visits only.",
          aviso: "In this period GA4 recorded {{registradas}} visits. {{robos}} were bots, {{semLeitura}} left in under 2 seconds and {{equipe}} were the gallery team. The dashboard counts the {{reais}} visits in which someone read the page.",
          kpiReais: "Real visits",
          kpiBrasil: "From Brazil",
          kpiPaginas: "Pages read",
          kpiTempo: "Reading time",
          kpiPedidos: "Information requests",
          kpiBrasilHint: "{{pct}}% of real visits",
          kpiPaginasHint: "{{n}} per visit",
          kpiTempoHint: "average per real visit",
          kpiPedidosHint: "forms opened, search excluded",
          vsAnterior: "{{sinal}}{{pct}}% vs previous period ({{valor}})",
          mesesTitulo: "Visits per month · real × recorded",
          legReais: "real",
          legOutras: "bots and visits without reading",
          origensTitulo: "Where visits come from",
          colOrigem: "Source",
          colChegaram: "Arrived",
          colLeram: "Read",
          colPct: "% who read",
          origem: {
            busca: "Search (Google and others)",
            direto: "Direct or saved link",
            redes: "Organic Instagram and Facebook",
            email: "Email",
            anuncios: "Ads",
            ia: "AI assistants (ChatGPT and others)",
            outros_sites: "Other sites",
            outros: "Unidentified source",
          },
          tipos: {
            artista: "Artists",
            exposicao: "Exhibitions",
            viewing_room: "Viewing Room",
            obra: "Artworks",
            todas: "All pages",
          },
          buscaPlaceholder: "Search page or title",
          soSemVinculo: "only without an Acervo link",
          colPagina: "Page",
          colLeituras: "Reads",
          colSemLeitura: "Without reading",
          colTempo: "Time per read",
          colAcervo: "In the Acervo",
          abrirAcervo: "open in the Acervo",
          semCadastro: "not registered",
          duplicada: "duplicate page on the site",
          vinculoProximaFase: "link in the next phase",
          notaPaginas: "Read = page viewed in a real visit. Without reading = page opened by someone who left in under 2 seconds. Bots and team are excluded. Portuguese and English combined.",
          nenhumaPagina: "No pages found.",
          qtdPaginas: "{{n}} pages",
          semDados: "No site data for the period.",
          naoConfigurado: "BigQuery is not configured on the server.",
          comoContamos: "How we count: a visit is real when the person keeps the page open for at least 2 seconds and views at least one page. Bots (known browser signature) and the gallery team (test site, Meta ads manager, Mailchimp) are excluded.",
          carregando: "Reading site data… the first query of the day takes a few seconds.",
          card: {
            titulo: "On the site · last 30 days",
            leituras: "reads of the artist page",
            posicao: "#{{pos}} of {{total}} artists",
            vs: "{{sinal}}{{pct}}% vs previous 30 days ({{valor}})",
            origens: "Where reads come from",
            semDados: "No reads of the artist page in this period.",
            verRelatorio: "see site report",
          },
        },
        newsletter: {
          tituloSecao: "Newsletter",
          subtitulo: "{{count}} campaigns in the last 12 months",
          kpis: {
            campanhas12m: "Campaigns (12m)",
            taxaAberturaMedia: "Average Open Rate (12m)",
            referenciaConta: "account reference: {{pct}}",
            cliquesHumanos: "Human Clicks",
            cliquesHumanosHint: "{{human}} human · {{bot}} bot",
            cliquesHumanosComparativo: "full history: {{pct}} human",
            cliquesHumanosExplicacao:
              "A click is flagged as a likely bot when it happens before the email is opened, or in a group (3 or more within the same second) — a typical corporate scanner signature (Safe Links, Proofpoint). This is an estimate, not an absolute certainty.",
            ultimaSincronizacao: "Last Sync",
            nuncaSincronizado: "never synced",
          },
          evolucao: {
            titulo: "Campaign Trend",
            ariaLabel: "Chart showing open rate and click rate trend per campaign",
            legendaAbertura: "Open rate",
            legendaClique: "Click rate",
          },
          melhorEnvio: {
            tituloSecao: "Best Day / Best Time to Send",
            melhorDia: "Best Day",
            melhorHorario: "Best Time",
            amostraInsuficiente: "Insufficient sample to recommend.",
            campanhasAnalisadas: "based on {{count}} campaigns",
          },
          lista: {
            titulo: "Latest Campaigns",
            verTodas: "See all campaigns",
            colCampanha: "Campaign",
            colData: "Date",
            colAbertura: "Open rate",
            colClique: "Click rate",
          },
          vazio: {
            titulo: "No campaigns synced yet",
            descricao:
              "Sync Mailchimp campaign reports to see newsletter metrics here.",
            cta: "Go to Email Campaigns",
          },
        },
        conta: {
          tituloSecao: "Profile Performance",
          ultimosDias: "last {{dias}} days",
          seguidores: "Followers",
          alcance: "Reach",
          alcanceHint: "unique accounts reached",
          visualizacoes: "Views",
          visualizacoesHint: "content views",
          interacoes: "Interactions",
          interacoesHint: "likes · comments · saves",
          contasEngajadas: "Engaged Accounts",
          contasEngajadasHint: "engaged in the period",
          visitasPerfil: "Profile Visits",
          visitasPerfilHint: "profile opens",
        },
        naoConfigurado: {
          titulo: "BigQuery integration not configured",
          descricaoPre:
            "Instagram metrics are read live from BigQuery. To display them here, grant the service account",
          descricaoMeio: "the roles",
          e: "and",
          descricaoProjeto: "in project",
        },
        semDados: {
          titulo: "No data in the period",
          descricao:
            "The integration is configured, but no data has been loaded for this period in BigQuery yet.",
        },
        evolucao: {
          titulo: "Evolution Over the Period",
          ariaLabel: "Chart showing evolution of followers, interactions and daily reach",
          legendaAlcanceDiario: "Daily reach",
        },
        engajamento: {
          titulo: "Engagement Rate",
          subtitulo: "interactions ÷ reach, per week",
          legendaBarra: "Yellow bar = best week",
        },
        acoesPerfil: {
          titulo: "Profile Actions",
          cliquesSite: "Website Clicks",
          cliquesSiteHint: "bio link → galerialeme.com",
          tapsLinks: "Taps on Profile Links",
          tapsLinksHint: "total taps on links",
          telefoneEmailRota: "Phone · Email · Directions",
          descontinuados: "Discontinued by Meta in 2024.",
          descontinuadosDetalhe:
            "There is no way to collect these taps individually — Instagram no longer exposes them via the API.",
        },
        audiencia: {
          titulo: "Audience",
          subtitulo: "current snapshot of followers",
          genero: {
            titulo: "Gender",
            feminino: "Female",
            masculino: "Male",
            naoInformado: "Not informed",
          },
          faixaEtaria: {
            titulo: "Age Range",
            legendaBarra: "Yellow bar = dominant age range",
          },
          paises: {
            titulo: "Countries",
          },
          cidades: {
            titulo: "Cities",
          },
        },
        rodape: {
          nota: "Demographics always reflect the current snapshot of the audience — Meta does not provide historical series for this data. Account metrics cover up to 90 days (API limit); the full history is preserved in BigQuery starting Dec/2025.",
        },
        posts: {
          tituloSecao: "Recent Posts",
          ultimosPosts: "last {{count}} posts",
          periodo: {
            dias30: "Last 30 days",
            dias90: "Last 90 days",
            todos: "All",
            verAoVivo: "View live now",
            contagemComData:
              "{{count}} posts in period · data as of {{date}} · updated once a day",
          },
          naoConfiguradoTitulo: "Instagram integration not configured",
          naoConfiguradoDesc:
            "Per-post metrics are read live from the Instagram Graph API. This account does not have an access token configured for this integration yet.",
          kpis: {
            alcanceMedio: "Average Reach",
            interacoesMedias: "Average Interactions",
            taxaEngajamento: "Engagement Rate",
            taxaEngajamentoHint: "average · over reach",
            salvos: "Saves",
            views: "Views",
            porPost: "per post",
            somaPeriodo: "sum in the period",
          },
          scatter: {
            titulo: "Reach × Engagement",
            eixoX: "engagement rate →",
            eixoY: "reach →",
            legendaMelhor: "Best post",
          },
          melhorPost: {
            titulo: "Top post",
            metricas: "Reach {{alcance}} · Engag. {{engaj}}",
          },
          mediaType: {
            imagem: "Image",
            carrossel: "Carousel",
            reels: "Reels",
            outro: "Other",
          },
          horario: {
            titulo: "Best Time to Post",
            subtitulo: "average reach per day",
            legenda: "has the highest average reach.",
            amostraPequena:
              "Based on the last {{count}} posts — small sample, indicative trend.",
            dias: {
              dom: "Sun",
              seg: "Mon",
              ter: "Tue",
              qua: "Wed",
              qui: "Thu",
              sex: "Fri",
              sab: "Sat",
            },
          },
          melhorHorario: {
            melhorDia: "Best day: {{dia}} · {{alcance}} avg. reach",
            tituloFaixa: "Best Time Block",
            melhorFaixa: "Best time block: {{faixa}} · {{alcance}} avg. reach",
            faixa: {
              manha: "Morning",
              tarde: "Afternoon",
              noite: "Evening",
            },
          },
          lista: {
            titulo: "Posts in the Period",
            ordenarPor: "Sort by",
            alcance: "Reach",
            salvos: "Saves",
            views: "Views",
            interacoes: "Interactions",
            engajamento: "Engag.",
            data: "Date",
            semLegenda: "No caption",
          },
          ordenar: {
            alcance: "Reach",
            salvos: "Saves",
            views: "Views",
            interacoes: "Interactions",
            engajamento: "Engagement",
            recente: "Most recent",
          },
          filtro: {
            label: "Type",
            todos: "All",
            reels: "Reels",
            carrossel: "Carousel",
            imagem: "Image",
          },
          nenhumDoTipo: "No posts of this type.",
        },
        stories: {
          tituloSecao: "Stories",
          subtitulo: "{{active}} active of {{total}} collected",
          naoConfiguradoTitulo: "Instagram integration not configured",
          naoConfiguradoDesc:
            "Stories are collected periodically via the Instagram Graph API. This account does not have an access token configured for this integration yet.",
          semDados: {
            titulo: "Collection hasn't run yet",
            descricao:
              "Stories will appear here once the next collection runs (hourly). Since Instagram doesn't keep a history of stories, only what gets collected from now on can be shown — stories published before this feature existed cannot be recovered.",
          },
          kpis: {
            storiesAtivas: "Active Stories",
            alcanceMedio: "Average Reach",
            porStory: "per story",
            visualizacoesMedias: "Average Views",
            interacoesTotais: "Total Interactions",
            respostasTotais: "Total Replies",
            somaPeriodo: "sum in the period",
          },
          status: {
            ativa: "Active",
            expirada: "Expired",
          },
          tempo: {
            agora: "just now",
            minutos: "{{count}}m ago",
            horas: "{{count}}h ago",
            dias: "{{count}}d ago",
            mes: "in {{monthYear}}",
          },
          mediaType: {
            imagem: "Photo",
            video: "Video",
            outro: "Other",
          },
          lista: {
            titulo: "Collected Stories",
            visualizacoes: "Views",
            alcance: "Reach",
            respostas: "Replies",
            interacoes: "Interactions",
            publicadaEm: "Posted",
            dadosAte: "data as of {{time}}",
          },
        },
      },
      imprensa: {
        titulo: "Press Contacts",
        totalContatos_one: "{{countFormatted}} contact registered",
        totalContatos_other: "{{countFormatted}} contacts registered",
        filtrosAriaLabel: "Press-contact filters",
        limparBuscaAriaLabel: "Clear search",
        limpar: "Clear",
        topInteresse: "Top interest",
        contatoSelecionado: "Selected contact",
        busca: "Search journalist, outlet...",
        filtroVeiculo: "Outlet type",
        todosVeiculos: "All outlet types",
        colJornalista: "Journalist",
        colVeiculo: "Outlet",
        colBeat: "Beat",
        colCanais: "Channels",
        colScore: "Interest score",
        colUltimoContato: "Last contact",
        semContatos: "No press contacts found.",
        selecionePrompt: "Select a contact",
        selecionePromptSub: "Click a table row to open the full profile.",
        semAtividade: "No interaction recorded",
        optInConfirmado: "Confirmed",
        optInNaoConfirmado: "Not confirmed",
        consentimentoLgpd: "LGPD consent",
        temasInteresse: "Topics of interest",
        semTemas: "No topics recorded.",
        scoreInteresse: "Interest score",
        scoreNota: "Score v1 based on interaction recency; enriched with opens/clicks/downloads in Phase 2.",
        timelineAtividade: "Activity Timeline",
        semTimeline: "No activity recorded.",
        interacao: {
          visit: "visit",
          email: "email sent",
          whatsapp: "WhatsApp",
          phone: "call",
          meeting: "meeting",
          catalog_sent: "catalog sent",
          gift_sent: "gift sent",
          viewing_room_access: "accessed viewing room",
          event_attended: "attended event",
          other: "interaction",
        },
        tempo: {
          agora: "now",
          minutos: "{{count}}m ago",
          horas: "{{count}}h ago",
          dias: "{{count}}d ago",
          mes: "{{monthYear}}",
        },
        scoreTier: {
          alto: "High",
          medio: "Medium",
          baixo: "Low",
        },
        canalEmailCadastrado: "Email: {{email}}",
        canalSemEmail: "No email on file",
        canalWhatsappSemCanal: "WhatsApp — no channel on file",
        canalWhatsappOptInConfirmado: "WhatsApp — opt-in confirmed",
        canalWhatsappSemOptIn: "WhatsApp — no opt-in",
        mediaOutletType: {
          revista: "Magazine",
          jornal: "Newspaper",
          portal_site: "Portal / Website",
          tv: "TV",
          radio: "Radio",
          podcast: "Podcast",
          agencia: "Agency",
          independente: "Independent",
        },
      },
      pressReleases: {
        titulo: "Press Releases",
        totalReleases_one: "{{count}} release",
        totalReleases_other: "{{count}} releases",
        novoRelease: "New Release",
        filtrosAriaLabel: "Press-release filters",
        filtroStatus: "Status",
        todosStatus: "All statuses",
        filtroExposicao: "Exhibition",
        todasExposicoes: "All exhibitions",
        filtroIdioma: "Language",
        todosIdiomas: "All languages",
        idiomaPt: "Portuguese",
        idiomaEn: "English",
        colReleases: "Releases",
        noTotal_one: "{{count}} total",
        noTotal_other: "{{count}} total",
        semReleases: "No press releases yet.",
        selecionePrompt: "Select a release",
        selecionePromptSub: "Click a release in the list or create a new one.",
        embargoLabel: "Embargo",
        enviadoLabel: "Sent",
        semDataDefinida: "no date set",
        atualizadoEm: "last edited {{date}}",
        status: {
          rascunho: "Draft",
          revisao: "In review",
          aprovado: "Approved",
          embargo: "Embargo",
          enviado: "Sent",
        },
        editor: {
          titulo: "Bilingual editor",
          colPt: {
            header: "Português",
            titulo: "Título",
            corpo: "Corpo do texto",
          },
          colEn: {
            header: "English",
            titulo: "Title",
            corpo: "Body",
          },
          metaExposicao: "Exhibition",
          metaArtista: "Artist",
          metaEmbargo: "Embargo until",
          metaStatus: "Status",
          semExposicao: "None",
          semArtista: "None",
        },
        distribuicao: {
          titulo: "Multichannel distribution",
          destinatarios: "Recipients",
          destinatariosAriaLabel: "Select send recipients",
          destinatariosContagem: "{{selected}} of {{total}} press contacts selected",
          semContatos: "No press contacts registered.",
          emailConfirmado: "Email confirmed",
          semEmail: "No email on file",
          whatsappOptIn: "WhatsApp with opt-in",
          whatsappSemOptIn: "No WhatsApp opt-in",
          canais: "Send channels",
          canalEmail: "Email (Brevo)",
          canalEmailDesc: "Sent by email with our own open and click tracking.",
          canalWhatsapp: "WhatsApp (approved template)",
          canalWhatsappDesc: "Restricted to contacts with an active opt-in, via a pre-approved MARKETING-category template with Meta. Without opt-in or template, sending degrades to email only.",
          canalLabel: {
            email: "Email",
            whatsapp: "WhatsApp",
          },
          linksRastreados: "Every link in the release is rewritten as a tracked redirect — that's what feeds the engagement panel below.",
          enviar: "Send",
          enviando: "Sending...",
          nenhumDestinatarioErro: "Select at least one recipient.",
          nenhumCanalErro: "Select at least one send channel.",
          embargoAtivo: "This release is under embargo until {{date}} — sending will stay blocked until then.",
          agendado: "Send scheduled — follow it in the engagement panel below.",
          resultado_one: "{{count}} delivery scheduled.",
          resultado_other: "{{count}} deliveries scheduled.",
          puladosTitulo_one: "{{count}} recipient skipped:",
          puladosTitulo_other: "{{count}} recipients skipped:",
          puladoItem: "{{name}} ({{channel}}): {{reason}}",
          motivoPulado: {
            semEmail: "recipient has no email on file",
            semTelefone: "recipient has no phone on file",
            semOptInWhatsapp: "no WhatsApp opt-in",
            generico: "{{reason}}",
          },
        },
        engajamento: {
          titulo: "Engagement panel",
          semDistribuicao: "This release hasn't been distributed yet.",
          semDistribuicaoSub: "Send the release in the distribution section above to start tracking opens, clicks and downloads.",
          funil: "Distribution funnel",
          funilEnviado: "Sent",
          funilEntregue: "Delivered",
          funilAberto: "Opened",
          funilClicou: "Clicked",
          funilBaixou: "Downloaded",
          ranking: "Who's most interested",
          colJornalista: "Journalist",
          colVeiculo: "Outlet",
          colScore: "Score",
          colUltimoEvento: "Last event",
          semRanking: "No recipients yet.",
          timelineTitulo: "Timeline · {{name}}",
          timelineSemEventos: "No events recorded yet for this recipient.",
          selecionarParaTimeline: "View timeline for {{name}}",
          ressalva: "Email opens are a weak signal (Apple Mail Privacy Protection inflates this metric automatically); clicks and downloads are the reliable signals for prioritizing follow-up. WhatsApp \"read\" is approximate and depends on each contact's privacy settings.",
          eventType: {
            delivered: "Delivered",
            opened: "Opened",
            clicked: "Clicked",
            asset_downloaded: "Downloaded material",
            bounced: "Bounced",
          },
        },
      },
    },
    recipient_lists: {
      kind: {
        static: "Static",
        dynamic: "Dynamic",
      },
      status: {
        active: "Active",
        archived: "Archived",
      },
      count: {
        contacts: "Contacts",
        today: "Today",
      },
      bulk: {
        select_lists_placeholder: "Choose target list…",
        add_to_list: "Add to a list",
        selected: "{{n}} selected",
        modal_title: "Add {{n}} contacts to a list",
        added: "{{n}} added",
        duplicates: "{{n}} already in the list",
        clear: "Clear selection",
      },
    },
    common: {
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      create: "Create",
      edit: "Edit",
      view: "View catalog",
      delete: "Delete",
      remove: "Remove",
      search: "Search",
      loading: "Loading...",
      noResults: "No results found.",
      required: "Required field",
      viewAll: "View all",
      all: "All",
      allTypes: "All types",
      select: "Select...",
      next: "Next",
      back: "Back",
      close: "Close",
      retry: "Try again",
      new: "New",
      comingSoon: "Coming soon",
      notifications: "Notifications",
      userMenu: "User menu",
      errorTitle: "Error loading",
      errorMessage: "An error occurred while loading data.",
      showingOf: "Showing {{from}}–{{to}} of {{total}}",
      yes: "Yes",
      no: "No",
      download: "Download",
    },
    dashboard: {
      title: "Overview",
      updated: "Updated now",
      totalItems: "Total Items",
      distributed: "Distributed / Month",
      criticalStock: "Critical Stock",
      activeKits: "Active Kits",
      inLocations: "Across locations",
      thisMonth: "This month",
      belowThreshold: "Below threshold",
      remaining: "remaining",
      noAlerts: "No stock alerts.",
      recentShipments: "Recent Shipments",
    },
    artworks: {
      title: "Artworks",
      registered: "artworks registered",
      new: "New Artwork",
      edit: "Edit Artwork",
      search: "Search by title, artist or code",
      artistSearch: "Filter by artist",
      empty: "No artworks registered",
      emptyMessage: "Register the first artwork to start the commercial domain.",
      section: {
        identification: "Identification",
        technical: "Technical Sheet",
        notes: "Notes",
      },
      field: {
        title: "Title",
        artist: "Artist",
        internalCode: "Internal code",
        legacyCode: "Legacy code",
        year: "Year",
        medium: "Medium",
        support: "Support",
        dimensions: "Dimensions",
        edition: "Edition",
        location: "Location",
        status: "Status",
        price: "Price",
        currency: "Currency",
        image: "Primary image",
        imageUrl: "Image URL",
        notes: "Notes",
      },
      media: {
        select: "Select from library",
        clear: "Clear image",
        noSelection: "No media selected.",
        urlFallback: "Image defined by manual URL.",
        selectTitle: "Select artwork image",
        search: "Search media library",
      },
      status: {
        available: "Available",
        loaned: "Loaned",
        reserved: "Reserved",
        consigned_client: "Consigned client",
        sold: "Sold",
        returned_to_consignor: "Returned to consignor",
        donated: "Donated",
        destroyed: "Destroyed",
        undefined: "Undefined",
        unavailable: "Unavailable",
      },
      form: {
        errorRequired: "Title and artist are required.",
      },
      delete: {
        title: "Delete artwork",
        message: "Delete \"{{title}}\"? The artwork will be soft-deleted.",
      },
    },
    catalogs: {
      title: "Commercial Catalogs",
      registered: "catalogs registered",
      new: "New Catalog",
      edit: "Edit Catalog",
      search: "Search by name or slug",
      searchWorks: "Search artworks by title, artist or code",
      empty: "No catalogs registered",
      emptyMessage: "Create the first commercial catalog to assemble artwork selections.",
      selectedCount: "selected artworks",
      emptySelection: "No artworks selected yet.",
      field: {
        name: "Name",
        slug: "Slug",
        coverMedia: "Catalog cover",
        coverMediaEmpty: "No cover selected yet.",
        introText: "Intro text",
        status: "Status",
        liveUpdating: "Automatic content updates",
        notes: "Notes",
        addWorks: "Add artworks",
        visible: "Visible",
        sortOrder: "Order",
        layout: "Layout",
        primaryArtwork: "Primary artwork",
        secondaryArtwork: "Secondary artwork",
        viewImage: "View image",
        coverFromLibrary: "Select cover",
        clearCover: "Clear cover",
        selectArtwork: "Select artwork",
        selectSecondaryArtwork: "Select artwork 2",
        selectViewImage: "Select view",
        clearArtwork: "Clear artwork",
        clearSecondaryArtwork: "Clear artwork 2",
        clearViewImage: "Clear view",
        selectArtworkHelp: "Add spreads and, inside each one, choose the library view image and artworks that belong to that page.",
      },
      assembly: {
        title: "Spread assembly",
        empty: "Build the catalog spread by spread, choosing layout, primary artwork, secondary artwork and view image when needed.",
      },
      metrics: {
        spreads: "Spreads",
        updating: "Updating",
        updatedAt: "Updated at",
      },
      preview: {
        title: "Final Catalog Preview",
        spreads: "spreads",
        empty: "Add artworks and view images to preview the final catalog.",
        open: "Open final preview",
        hint: "Separate from assembly, approximating the final catalog/PDF output.",
        sectionCover: "Cover",
        sectionIntro: "Introduction",
        sectionSpread: "Spread {{number}}",
      },
      spread: {
        title: "Catalog spreads",
        add: "Add spread",
        remove: "Remove spread",
        empty: "No spreads added yet.",
      },
      picker: {
        coverTitle: "Select cover from library",
        viewTitle: "Select view image",
        artworkTitle: "Select primary artwork",
        secondaryArtworkTitle: "Select secondary artwork",
        empty: "No results found.",
      },
      status: {
        draft: "Draft",
        active: "Active",
        archived: "Archived",
      },
      layout: {
        vista: "Vista",
        "vista-dir": "Vista right",
        "vista-full": "Vista full page",
        full: "Artwork + sheet",
        "full-dir": "Sheet + artwork",
        "dupla-esq": "Double left",
        "dupla-dir": "Double right",
        "obra-texto": "Artwork + curatorial text",
        "texto-obra": "Curatorial text + artwork",
        "texto-pagina": "Text page",
        "capa-artista": "Artist cover",
        ocultar: "Hide",
      },
      form: {
        errorRequired: "Name and slug are required.",
      },
      delete: {
        message: "Delete \"{{name}}\"? The catalog will be soft-deleted.",
      },
      delivery: {
        cta: "Generate link",
        activeOnly: "The catalog must be active before generating a public link.",
        title: "Individual catalog link",
        searchRecipient: "Select recipient",
        searchPlaceholder: "Search recipient by name, email or phone",
        emptyRecipients: "No recipients found.",
        selectRecipientHint: "Select a recipient to generate an individual link.",
        generate: "Generate link",
        generatedLink: "Generated link",
        openPublic: "Open public page",
        copyLink: "Copy link",
        trackingTitle: "Recipient tracking",
      },
      public: {
        title: "Public Catalog",
        opens: "Opens",
        clicks: "Clicks",
        favorites: "Favorites",
        selected: "Selections",
      },
    },
    mediaAssets: {
      title: "Media Library",
      registered: "files registered",
      new: "New Asset",
      add: "Add file",
      edit: "Edit Asset",
      search: "Search by name, path or alt text",
      empty: "No files registered",
      emptyMessage: "Create the first media asset to reuse across artworks, catalogs and conversations.",
      upload: "File upload",
      selectFile: "Select file",
      changeFile: "Change file",
      selectFiles: "Select files",
      changeFiles: "Change files",
      filesSelected: "{{count}} file(s) selected",
      previewFirstOfMany: "Showing the preview of the 1st of {{count}} selected files.",
      previewEmpty: "Select a file to preview it here.",
      previewUnavailable: "Preview unavailable for this file type.",
      previewPdf: "PDF file ready for upload.",
      field: {
        kind: "Kind",
        originalName: "Original name",
        fileName: "File name",
        mimeType: "MIME type",
        fileSize: "File size",
        storageProvider: "Storage provider",
        storagePath: "Storage path",
        publicUrl: "Public URL",
        width: "Width",
        height: "Height",
        altText: "Alt text",
        status: "Status",
        preview: "Preview",
      },
      metrics: {
        updatedAt: "Updated at",
        provider: "Provider",
      },
      kind: {
        artwork_image: "Artwork image",
        catalog_cover: "Catalog cover",
        catalog_view: "View image",
        attachment: "Attachment",
        document: "Document",
        text: "Text",
      },
      status: {
        active: "Active",
        archived: "Archived",
      },
      form: {
        errorRequired: "Kind, names, MIME, storage path and public URL are required.",
        errorFileRequired: "Select a file to upload.",
        errorFileTooLarge: "File exceeds the {{max}} limit.",
        errorFileTypeNotAllowed: "File type not allowed. Use JPG, PNG, WebP, GIF, MP4 or PDF.",
        errorTooManyFiles: "Maximum {{max}} files per upload.",
        errorTotalSizeTooLarge: "Total file size exceeds {{max}}.",
        uploadHelp: "Upload JPG, PNG, WebP, GIF, MP4 or PDF (max. 50 MB each, 500 MB total, up to 20 files). Storage path, public URL, MIME type and file size will be filled automatically after upload. You can select multiple files at once.",
        altTextSharedHint: "The alt text will be applied to every selected file.",
        uploadingProgress: "Uploading file {{done}} of {{total}}… (parallel uploads, max 3 concurrent)",
        uploadErrorsTitle: "Failed to upload {{count}} file(s):",
      },
      delete: {
        message: "Delete \"{{name}}\"? The asset will be soft-deleted.",
      },
    },
    items: {
      viewShipment: "View shipment →",
      title: "Item Catalog",
      registered: "items registered",
      new: "New Item",
      empty: "No items registered",
      emptyMessage: "Register the first item in the collection.",
      tab: {
        general: "General",
        images: "Images",
        files: "Files",
        stock: "Stock",
        history: "History",
      },
      section: {
        identification: "Identification",
        acquisition: "Acquisition",
        book: "Book Details",
        quick_actions: "Quick Actions",
        stock_summary: "Stock Summary",
        locations: "Locations",
      },
      book: {
        author: "Author",
        isbn: "ISBN",
        publisher: "Publisher",
        edition: "Edition",
        year: "Publication Year",
      },
      field: {
        name: "Name",
        code: "Code",
        category: "Category",
        subcategory: "Subcategory",
        operational_type: "Operational Type",
        status: "Status",
        description: "Description",
        origin: "Origin",
        supplier: "Supplier",
        acquisition_date: "Acquisition Date",
        unit_cost: "Unit Cost",
      },
      action: {
        entry: "Register Entry",
        transfer: "Transfer",
        new_shipment: "New Shipment",
      },
      stock: { total: "total in stock" },
      meta: { created_at: "Created at", updated_at: "Updated at" },
      form: {
        newTitle: "New item",
        editTitle: "Edit item",
        name: "Name",
        category: "Category",
        subcategory: "Subcategory",
        itemKind: "Kind",
        status: "Status",
        productCode: "Code (SKU)",
        description: "Description",
        unitCost: "Unit cost",
        origin: "Origin",
        notes: "Notes",
        coverImage: "Cover image",
        coverImageHint: "Click to pick an image",
        coverImageReplaceHint: "Selecting an image here will replace the current cover.",
        initialStockSection: "Initial stock (optional)",
        initialQuantity: "Initial quantity",
        initialLocation: "Initial location",
        entryDate: "Entry date",
        initialStockHint:
          "Fill all three to register an immediate stock entry. Accepts retroactive dates.",
        bookSection: "Book information",
        bookAuthor: "Author",
        bookIsbn: "ISBN",
        bookPublisher: "Publisher",
        bookEdition: "Edition",
        bookYear: "Publication year",
        errorNameRequired: "Name is required.",
        errorQtyInvalid: "Invalid quantity.",
        errorQtyRequired: "Fill the entry quantity for initial stock.",
        errorLocationRequired:
          "Fill the initial location to register the entry.",
      },
      kind: {
        book: "Book",
        catalog: "Catalog",
        gift: "Gift",
        bag: "Bag",
        printed_material: "Printed material",
        packaging: "Packaging",
        institutional: "Institutional item",
        campaign_item: "Campaign item",
        other: "Other",
      },
      status: {
        active: "Active",
        inactive: "Inactive",
        discontinued: "Discontinued",
      },
      origin_type: {
        purchase: "Purchase",
        produced: "In-house production",
        donated: "Donation",
        partnership: "Partnership",
        transfer_in: "External transfer",
      },
      delete: {
        title: "Delete item",
        message: "Delete \"{{name}}\"? The item will be soft-deleted.",
      },
    },
    categories: {
      title: "Categories",
      subtitle: "Manage item categories and subcategories",
      panel: { categories: "Categories", subcategories: "Subcategories" },
      new_category: "New Category",
      new_subcategory: "New Subcategory",
      selectCategory: "Select a category",
    },
    locations: {
      title: "Locations",
      subtitle: "Hierarchical storage structure",
      new: "New Location",
      addSublocal: "+ Sublocation",
      inactivate: "Deactivate",
      activate: "Activate",
      confirmInactivate: "Deactivate this location? It will no longer appear in selections.",
      confirmActivate: "Reactivate this location?",
      confirmDelete: "Permanently delete \"{{name}}\"? Only works when it has no sub-locations or stock — otherwise use deactivate.",
      tree: { title: "Location Tree" },
      field: { type: "Type", capacity: "Capacity", children: "Sub-locations" },
      status: { active: "Active", inactive: "Inactive" },
      selectLocation: "Select a location",
      children: "Sub-locations",
      form: {
        newTitle: "New location",
        editTitle: "Edit location",
        name: "Name",
        type: "Type",
        code: "Code",
        parent: "Parent location",
        noParent: "— (no parent, root)",
        parentHint: "Choose the location that contains this one. Leave empty to create a root location.",
        notes: "Notes",
        isActive: "Active (shown in pickers)",
        errorNameRequired: "Name is required.",
      },
      type: {
        unit: "Unit",
        room: "Room",
        stock_area: "Stock area",
        shelf: "Shelf",
        cabinet: "Cabinet",
        box: "Box",
        dispatch_area: "Dispatch area",
        external_storage: "External storage",
      },
    },
    stock: {
      title: "Inventory",
      records: "balance records",
      col: { item: "Item", location: "Location", status: "Status" },
      available: "Available",
      reserved: "Reserved",
      damaged: "Damaged",
      total: "Total",
    },
    movements: {
      title: "Movements",
      records: "movements recorded",
      col: {
        type: "Type",
        item: "Item",
        qty: "Qty",
        from: "From",
        to: "To",
        justification: "Justification",
        date: "Date",
      },
      type: {
        entry: "Entry",
        transfer: "Transfer",
        shipment_out: "Shipment out",
        offline_action_out: "Offline action out",
        return_in: "Return",
        loss: "Loss",
        damage: "Damage",
        inventory_adjustment: "Inventory adjustment",
        write_off: "Write off",
        reservation: "Reservation",
        reservation_release: "Reservation release",
      },
    },
    recipients: {
      title: "Recipients",
      registered: "recipients registered",
      new: "New Recipient",
      viewTimeline: "View Timeline",
      timeline: "Interaction timeline",
      timelineEmpty: "No events recorded",
      saleEventPrivate: "Financial information restricted",
      selectPrompt: "Select a recipient",
      selectPromptSub: "Choose a contact from the list on the left to view details",
      col: { name: "Name", type: "Type", status: "Relationship", email: "Email", city: "City", tags: "Tags", lastInteraction: "Last interaction" },
      type: {
        institution: "Institution",
        gallery: "Gallery",
        collector: "Collector",
        curator: "Curator",
        journalist: "Journalist",
        artist: "Artist",
        client: "Client",
        press: "Press",
        partner: "Partner",
        supplier: "Supplier",
        transport: "Transport",
        internal_team: "Internal Team",
        art_advisor: "Art Advisor",
        architect: "Architect",
        decorator: "Decorator",
        other: "Other",
      },
      status: {
        lead: "Lead",
        prospect: "Prospect",
        customer: "Customer",
        vip: "VIP",
        collector: "Collector",
        architect: "Architect",
        advisor: "Advisor",
        supplier: "Supplier",
        transport: "Transport",
        imprensa: "Press",
        curator: "Curator",
        inactive: "Inactive",
      },
      tab: {
        contact: "Contact",
        observations: "Notes",
        preferences: "Preferences",
        lgpd: "LGPD",
        fiscal: "Fiscal",
        timeline: "Timeline",
        lists: "Lists",
        lists_empty_title: "This recipient is not in any list",
        lists_empty_desc: "Create a list in Commercial → Lists and add this contact.",
        lists_static_title: "Static lists",
        lists_static_empty: "No static lists.",
        lists_dynamic_title: "Dynamic lists",
        lists_dynamic_empty: "No dynamic lists match this contact.",
        shipments: "Shipments",
        analytics: "Analytics",
        emails: "Emails",
      },
      section: {
        contact: "Contact Info",
        details: "Details",
        metrics: "CRM Metrics",
        address: "Address",
        social: "Social Networks",
        communication: "Communication",
        fiscal: "Fiscal Data",
        interests: "Artistic Preferences",
        conversations: "Conversations",
        tags: "Tags",
        actions: "Suggested Actions",
      },
      field: {
        email: "Email",
        phone: "Phone",
        city: "City",
        state: "State",
        country: "Country",
        role: "Role",
        lead_source: "Lead Source",
        classification: "Classification",
        classifications: "Classifications",
        keywords: "Keywords",
        notes: "Notes",
        address: "Address",
        district: "District",
        postal_code: "Postal Code",
        company: "Company",
        birthday: "Birthday",
        client_since: "Client since",
        owner: "Owner",
        channel: "Preferred Channel",
        instagram: "Instagram",
        linkedin: "LinkedIn",
        facebook: "Facebook",
        twitter: "Twitter / X",
        website: "Personal Website",
        external_id: "External ID",
        media_outlet_type: "Outlet Type",
        document: "CPF / CNPJ",
      },
      lgpd: {
        title: "LGPD Consents",
        subtitle: "Record the channels authorized by the contact for communication.",
        email: "Email Marketing",
        whatsapp: "WhatsApp",
        sms: "SMS",
        phone: "Phone Call",
        mail: "Physical Mail",
        consented_at: "Consent date",
        legal: "Consents are stored in compliance with the General Data Protection Law (LGPD — Law 13.709/2018). Never send communications without recorded consent.",
        granted: "Authorized",
        denied: "Not authorized",
      },
      metric: {
        totalShipments: "Total Shipments",
        totalSalesCount: "Purchases",
        itemsSent: "Items Sent",
        shipments12m: "Shipments (12 mo.)",
        interactions90d: "Interactions (90 days)",
        ltv: "Total LTV",
        avgTicket: "Avg. Ticket",
        firstPurchase: "First Purchase",
        lastPurchase: "Last Purchase",
        totalInteractions: "Interactions",
      },
      meta: { created_at: "Created at", updated_at: "Updated at" },
      action: {
        edit: "Edit",
        registerInteraction: "Register Interaction",
        newConversation: "New conversation",
        openConversations: "View conversations",
        viewTimeline: "View Full Timeline",
        sendCatalog: "Send catalog",
        inviteVernissage: "Invite to vernissage",
        optOut: "Do not disturb",
        undoOptOut: "Remove opt-out",
      },
      optOut: {
        badge: "Do Not Disturb",
        badgeSince: "Off list since {{date}}",
        confirmTitle: "Register opt-out",
        dateLabel: "Opt-out date",
        confirmLabel: "Reason (optional)",
        confirmPlaceholder: "E.g.: requested via email, STOP on WhatsApp…",
        confirmButton: "Confirm opt-out",
        undoConfirm: "Remove opt-out for this contact?",
      },
      conversations: {
        empty: "No linked conversations yet.",
        noSubject: "No subject",
        unassigned: "Unassigned",
      },
      interaction: {
        title: "Register Interaction",
        type: "Interaction Type",
        channel: "Channel",
        subject: "Subject",
        notes: "Notes",
        date: "Date",
        save: "Save Interaction",
        types: {
          visit: "Visit",
          email: "Email",
          whatsapp: "WhatsApp",
          phone: "Phone",
          meeting: "Meeting",
          catalog_sent: "Catalog Sent",
          gift_sent: "Gift Sent",
          viewing_room_access: "Viewing Room Access",
          event_attended: "Event Attended",
          other: "Other",
          opt_out: "Opt-out registered",
          opt_out_removed: "Opt-out removed",
        },
      },
      editModal: {
        title: "Edit Recipient",
        section: {
          personal: "Personal Data",
          contact: "Contact",
          address: "Address",
          social: "Social Networks",
          crm: "CRM",
        },
      },
      filter: {
        all: "All",
        status: "Status",
        type: "Type",
        tag: "Tag",
        origin: "Origin",
      },
      shipments: {
        col: {
          date: "Date",
          number: "Number",
          items: "Items",
          status: "Status",
          actions: "Actions",
        },
        empty: "No shipments for this recipient",
      },
      empty: "No recipients found",
    },
    conversations: {
      title: "Conversations",
      registered: "conversations registered",
      new: "New Conversation",
      messages: "Messages",
      messageTimeline: "Conversation timeline",
      selectPrompt: "Select a conversation",
      selectPromptSub: "Choose a conversation on the left to view details",
      empty: "No conversations found",
      emptyMessage: "Create the first conversation to start relational follow-up.",
      emptyMessages: "No messages recorded yet.",
      filteredRecipient: "Focused recipient",
      clearRecipientFilter: "Clear filter",
      searchPlaceholder: "Search by subject, recipient or assignee",
      emptyFilteredMessage: "No conversations found with the current filters.",
      filter: {
        allAssignees: "All assignees",
      },
      sort: {
        updatedDesc: "Most recent first",
        updatedAsc: "Oldest first",
        recipientAsc: "Recipient (A-Z)",
      },
      field: {
        recipient: "Recipient",
        assignee: "Assignee",
        status: "Status",
        subject: "Subject",
        direction: "Direction",
        content: "Message",
        createdBy: "Created by",
        createdAt: "Created at",
        updatedAt: "Updated at",
      },
      status: {
        open: "Open",
        in_progress: "In progress",
        closed: "Closed",
      },
      direction: {
        inbound: "Inbound",
        outbound: "Outbound",
        internal: "Internal",
        system: "System",
      },
      saveSuccess: "Conversation updated.",
      createSuccess: "Conversation created.",
      messageCreateSuccess: "Message recorded.",
      messageUpdateSuccess: "Message updated.",
      messageDeleteSuccess: "Message removed from the visible history.",
      messageDeleteConfirm: "Remove this message from the visible history?",
      addMessage: "Add message",
      sendMessage: "Save message",
      editMessage: "Edit message",
      deleteMessage: "Delete message",
    },
    shipments: {
      title: "Shipments",
      registered: "shipments registered",
      searchPlaceholder: "Search by shipment no., recipient, artwork or tracking",
      dateFrom: "From",
      dateTo: "To",
      clearFilters: "Clear filters",
      exportReport: "Export report",
      exporting: "Generating...",
      exportError: "Could not generate the report.",
      new: "New Shipment",
      recipient: "Recipient",
      method: "Method",
      items: "Items",
      status: "Status",
      tracking: "Tracking",
      date: "Date",
      confirm: "Confirm Shipment",
      addItem: "Add Item",
      step: { header: "Header", items: "Items", confirm: "Confirmation" },
      field: { recipient: "Recipient", method: "Shipping method", weight: "Total weight (kg)", weightHint: "Used in the Correios Content Declaration.", notes: "Notes", item: "Item", location: "Location", qty: "Quantity" },
      statusValue: {
        pending: "Pending",
        separated: "Separated",
        dispatched: "Dispatched",
        delivered: "Delivered",
        returned: "Returned",
        lost: "Lost",
        cancelled: "Cancelled",
      },
      methodValue: {
        courier: "Courier",
        correios: "Brazilian Post (Correios)",
        transport_company: "Courier company",
        hand_delivery: "Hand delivery",
        pickup: "Pickup",
        internal_delivery: "Internal delivery",
      },
      declaracao: {
        button: "Content Declaration",
        title: "Content Declaration",
        sender: "Sender",
        recipient: "Recipient",
        senderSource: "Sender",
        senderGallery: "Gallery (default)",
        senderOther: "Other (registered recipient)",
        selectSender: "Select the sender…",
        goods: "Identification of goods",
        colItem: "Item",
        colContent: "Content",
        colQty: "Quantity",
        colValue: "Value",
        totals: "Totals",
        totalWeight: "Total weight (kg)",
        name: "Name",
        address: "Address",
        city: "City",
        state: "State",
        postalCode: "Postal code",
        document: "Tax ID",
        print: "Print / Save PDF",
        legal:
          "I declare that I am not subject to taxpayer status under art. 4 of Complementary Law 87/1996, as I do not carry out, habitually or in commercial volume, operations involving the circulation of goods, or I am exempt from issuing an invoice under current tax law, being liable, under the law, for untrue information. I further declare that I am not posting flammable, explosive, self-combusting, toxic, corrosive, gaseous or any other dangerous content, per art. 13 of Postal Law 6.538/78.",
        observation:
          "NOTE: It is a crime against the tax order to suppress or reduce a tax, social contribution or any accessory (Law 8.137/90 Art. 1, V).",
        signature: "Signature of the Declarant/Sender",
      },
    },
    kits: { title: "Kits", new: "New Kit" },
    galleryConfig: {
      title: "Gallery Settings",
      subtitle:
        "Data used in PDFs and the Correios Content Declaration (sender, bank).",
      saved: "Changes saved.",
    },
    offlineActions: {
      title: "Offline Actions",
      registered: "actions recorded",
      new: "New action",
      edit: "Edit action",
      back: "Offline actions",
      empty: "No actions recorded yet.",
      col: { name: "Name", status: "Status", location: "Location", dates: "Period", responsible: "Owner" },
      filter: { all: "All statuses" },
      type: {
        gifting: "Gifting",
        relationship: "Relationship",
        institutional_shipping: "Institutional shipping",
        fair_support: "Fair support",
        press: "Press",
        year_end_action: "Year-end action",
        special_campaign: "Special campaign",
        other: "Other",
      },
      status: { planned: "Planned", active: "Active", finished: "Finished", cancelled: "Cancelled" },
      actions: { active: "Start", finished: "Finish", cancelled: "Cancel action" },
      form: {
        name: "Name",
        type: "Type",
        responsible: "Owner",
        startDate: "Start",
        endDate: "End",
        campaign: "Campaign",
        description: "Description",
      },
      tabs: {
        lista: "List",
        lotes: "Batches & picking",
        rotas: "Routes & delivery",
        acompanhamento: "Tracking",
        soon: "soon",
      },
      header: {
        responsible: "owner",
        costs: "Set up costs",
        exportSheet: "Export spreadsheet",
        pickingList: "Picking list",
      },
      planejados: {
        empty: "No planned items or kits for this action.",
        item: "Item / kit",
        planned: "Planned",
        used: "Used",
        hint: "Planned items come from the action record. What each person receives lives in the List tab.",
      },
      lista: {
        card: {
          pessoas: "People",
          pessoasSub: "{{brindes}} gifts · {{semBrinde}} without gift",
          ok: "Address ok",
          okSub: "with postcode and number",
          confirmar: "Confirm",
          confirmarSub: "no postcode or approximate",
          semEndereco: "No address",
          semEnderecoSub: "ask the team",
          foraSp: "Outside SP",
          foraSpSub: "go by post",
          retira: "Pickup / by hand",
          retiraSub: "artists and team",
        },
        crmFiltersHint: "CRM filters (classification · bought in the last 3 years · VIP · received in 2025): coming in phase 2.",
        corrigir: "fix",
        vai: {
          ok: "ok",
          confirmar: "confirm",
          sem_endereco: "no address",
          fora_sp: "outside SP → post",
          retira: "picks up at the gallery",
          nao_checado: "not checked",
        },
        hint: {
          semEndereco: "no address in CRM",
          confirmar: "Google read: {{google}}",
          foraSp: "{{cidade}} · goes by post",
          retira: "not in a batch",
        },
        legend: {
          ok: "geocoded to the number",
          confirmar: "Google found only the street or district",
          sem_endereco: "stays out of batches until fixed",
          fora_sp: "goes by post automatically",
          retira: "artists and team",
        },
        kpi: {
          total: "On the list",
          ok: "Address OK",
          conferir: "Check",
          semEndereco: "No address",
          foraSp: "Outside SP",
          semBrinde: "No gift",
          envios: "Shipments created",
          naoChecado: "{{count}} address(es) not checked on Google yet — click “Check addresses”.",
          brindesTotal: "{{count}} gifts",
        },
        btn: {
          crm: "from CRM",
          list: "from a list",
          sheet: "Import spreadsheet",
          geocode: "Check addresses",
          bulkGift: "Gift for everyone",
          pdf: "Picking PDF",
          ship: "Create shipments ({{count}})",
        },
        search: "Search by name…",
        showing: "{{shown}} of {{total}}",
        empty: "The list is empty. Add people from the CRM, from a recipient list, or import the team spreadsheet.",
        noGift: "no gift",
        col: {
          name: "Name",
          pessoa: "Person",
          brinde: "Gift · variation",
          qtd: "Qty",
          vai: "Goes",
          gift: "Gift",
          address: "Delivery address",
          shipment: "Shipment",
          category: "Category",
          responsible: "Owner (team)",
          notes: "Notes",
        },
        source: { crm: "CRM", list: "list", sheet: "spreadsheet", manual: "manual" },
        semaforo: {
          ok: "OK",
          conferir: "Check",
          falhou: "Not found",
          sem_endereco: "No address",
          nao_checado: "Not checked",
        },
        geo: {
          done: "Checked {{checked}}: {{ok}} OK, {{conferir}} to review, {{falhou}} not found. Skipped: {{skipped_no_address}} without address, {{skipped_already}} already checked.",
        },
        addDone: "{{added}} added; {{already_in_list}} already on the list.",
        addCrm: {
          title: "Add from CRM",
          submit: "Add {{count}}",
          search: "Recipient",
          searchHint: "Type the name (at least 2 letters)…",
          empty: "Nobody found with that name.",
        },
        addList: {
          title: "Add from a recipient list",
          submit: "Add everyone on the list",
          list: "List",
          hint: "People already on the gift list are not added twice.",
        },
        sheet: {
          title: "Import team spreadsheet",
          intro: "Use the spreadsheet as the team builds it (columns like Name, Address, QTY, SIZE, Category, Notes, in any order). We first show a preview matching names to the CRM; nothing is saved until you confirm.",
          preview: "Preview",
          back: "Change file",
          confirm: "Add {{count}} to the list",
          counts: "{{use}} from CRM · {{create}} new records · {{skip}} skipped",
          giftDefault: "Gift for all rows",
          giftDefaultHint: "Quantity and size come from each spreadsheet row.",
          addressPolicy: "Spreadsheet address",
          addressAuto: "Save only for people without an address on record",
          addressAlways: "Always save as a new address (and use it for delivery)",
          addressNever: "Ignore; use the address on record",
          colName: "Name in sheet",
          colGift: "Qty / size",
          colAddress: "Address in sheet",
          colMatch: "In CRM",
          colDecision: "What to do",
          match: {
            exata: "Found",
            provavel: "Likely",
            possivel: "Similar",
            nenhuma: "Not found",
            ja_na_lista: "Already listed",
          },
          useCandidate: "Use: {{name}} ({{extra}})",
          noAddress: "no address",
          createNew: "Create new record",
          skipRow: "Skip this row",
          done: "{{added}} added, {{created_recipients}} new record(s), {{addresses_created}} address(es) created. {{already_in_list}} already on the list; {{skipped}} skipped.",
        },
        edit: {
          address: "Address for this delivery",
          addressPrimary: "Primary on record",
          addressHint: "To fix or add an address, open the recipient.",
          openRecipient: "Open recipient",
          googleRead: "As read by Google",
          pickup: "Picks up at the gallery / by hand",
          pickupHint: "Artists and team: stays out of batches and routes.",
        },
        ship: {
          title: "Create shipments",
          intro: "Creates a pending shipment for every person on the list with a gift and no shipment yet. Nothing leaves stock now: deduction happens when the shipment is confirmed in Shipments.",
          method: "Shipping method",
          methodHint: "Can be changed later, shipment by shipment. In phase 2 the method comes from the batch.",
          submit: "Create {{count}} shipment(s)",
          done: "{{count}} shipment(s) created, pending.",
          note: "Until phase 2 (batches and routes), shipments can be created straight from the list: one pending shipment per person with a gift.",
        },
        bulk: {
          title: "Gift for everyone without one",
          intro: "Sets the same gift for every person on the list who still has no gift.",
          submit: "Apply to {{count}} without gift",
          done: "Gift set on {{count}} row(s).",
        },
        remove: {
          title: "Remove from list",
          message: "Remove {{name}} from the gift list? The CRM record is not changed.",
        },
        gift: {
          item: "Item",
          kit: "Kit",
          none: "— to define —",
          quantity: "Quantity",
          variation: "Size / variation",
          variationHint: "e.g. 37, 41/43",
        },
      },
    },
    audit: {
      title: "Audit",
      records: "records",
      detail: "Record Details",
      selectLog: "Select a record to see details",
      col: { action: "Action", table: "Table", record: "Record", user: "User", date: "Date" },
    },
    users: {
      title: "Users",
      registered: "users",
      col: { name: "Name", email: "Email", roles: "Roles", status: "Status", created: "Created" },
    },
    imports: {
      title: "Import Data",
      subtitle: "Upload client and sales spreadsheets",
      upload: "File Upload",
      preview: "Preview",
      history: "Import History",
      type: { clients: "Clients", sales: "Sales" },
      col: { file: "File", status: "Status", rows: "Rows", user: "User", date: "Date" },
      rowsDetected: "rows detected",
      columns: "columns",
      dropzone: { title: "Drag a file here or click to select", formats: "CSV, XLSX, XLS" },
      step: {
        upload: "Upload",
        preview: "Preview",
        importing: "Importing",
        done: "Done",
      },
      analyze: "Analyze file",
      analyzing: "Analyzing...",
      confirmImport: "Confirm import",
      importingMessage: "Importing {{count}} records... This may take a few minutes.",
      elapsed: "Elapsed time",
      resultSuccess: "Import completed successfully",
      resultError: "Import completed with errors",
      totalProcessed: "Total processed",
      success: "Success",
      errors: "Errors",
      totalTime: "Total time",
      viewErrors: "View error details",
      downloadErrors: "Download errors (XLSX)",
      errorsTruncated: "Showing {{shown}} of {{total}} errors. Download the XLSX to see all.",
      errorsDrawer: {
        title: "Import errors",
        entries: "errors",
        searchPlaceholder: "Search by row, ID or message...",
        row: "Row",
        externalId: "External ID",
        message: "Message",
        noErrors: "This import has no recorded errors.",
      },
      importAnother: "Import another file",
      viewRecipients: "View Recipients",
      mapping: "Column mapping",
      rollback: "Rollback",
      rollbackConfirm: "Are you sure you want to rollback this import?",
      rollbackTitle: "Rollback import",
      status: {
        completed: "Completed",
        failed: "Failed",
        processing: "Processing",
        pending: "Pending",
        rolled_back: "Rolled back",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "pt-BR": ptBR,
      pt: ptBR,
      en,
    },
    fallbackLng: "pt-BR",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
